import { Contestant } from '../types';

// RuPaul's Drag Race Main US Season Contestants Database
// Only includes main seasons (1-17), first appearance only for multi-season contestants
// Data includes season, finishing position, age at time of show, hometown, coordinates, and image URLs

// City coordinates lookup for hometown proximity calculations
const cityCoordinates: Record<string, { latitude: number; longitude: number }> = {
  'Minneapolis, Minnesota': { latitude: 44.9778, longitude: -93.2650 },
  'Bayamón, Puerto Rico': { latitude: 18.3985, longitude: -66.1553 },
  'Fort Lauderdale, Florida': { latitude: 26.1224, longitude: -80.1373 },
  'Las Vegas, Nevada': { latitude: 36.1699, longitude: -115.1398 },
  'Los Angeles, California': { latitude: 34.0522, longitude: -118.2437 },
  'Chicago, Illinois': { latitude: 41.8781, longitude: -87.6298 },
  'Cleveland, Ohio': { latitude: 41.4993, longitude: -81.6944 },
  'Glen Burnie, Maryland': { latitude: 39.1626, longitude: -76.6247 },
  'Raleigh, North Carolina': { latitude: 35.7796, longitude: -78.6382 },
  'Orlando, Florida': { latitude: 28.5383, longitude: -81.3792 },
  'Riverside, California': { latitude: 33.9533, longitude: -117.3962 },
  'Boston, Massachusetts': { latitude: 42.3601, longitude: -71.0589 },
  'Falls Church, Virginia': { latitude: 38.8823, longitude: -77.1711 },
  'Rochester, New York': { latitude: 43.1566, longitude: -77.6088 },
  'San Juan, Puerto Rico': { latitude: 18.4655, longitude: -66.1057 },
  'New York, New York': { latitude: 40.7128, longitude: -74.0060 },
  'Scotland Neck, North Carolina': { latitude: 36.1296, longitude: -77.4203 },
  'Atlanta, Georgia': { latitude: 33.7490, longitude: -84.3880 },
  'Paris, Texas': { latitude: 33.6609, longitude: -95.5555 },
  'St. Petersburg, Florida': { latitude: 27.7676, longitude: -82.6403 },
  'Manati, Puerto Rico': { latitude: 18.4285, longitude: -66.4827 },
  'Elmwood Park, New Jersey': { latitude: 40.9040, longitude: -74.1185 },
  'Norwalk, California': { latitude: 33.9022, longitude: -118.0817 },
  'Back Swamp, North Carolina': { latitude: 35.4585, longitude: -77.1369 },
  'Dayton, Ohio': { latitude: 39.7589, longitude: -84.1916 },
  'Pittsburgh, Pennsylvania': { latitude: 40.4406, longitude: -79.9959 },
  'San Diego, California': { latitude: 32.7157, longitude: -117.1611 },
  'South Beach, Florida': { latitude: 25.7907, longitude: -80.1300 },
  'Dorado, Puerto Rico': { latitude: 18.4588, longitude: -66.2677 },
  'Tampa, Florida': { latitude: 27.9506, longitude: -82.4572 },
  'Seattle, Washington': { latitude: 47.6062, longitude: -122.3321 },
  'Mesquite, Texas': { latitude: 32.7668, longitude: -96.5992 },
  'Gainesville, Florida': { latitude: 29.6516, longitude: -82.3248 },
  'San Francisco, California': { latitude: 37.7749, longitude: -122.4194 },
  'Owensboro, Kentucky': { latitude: 37.7719, longitude: -87.1112 },
  'Tallahassee, Florida': { latitude: 30.4383, longitude: -84.2807 },
  'Cincinnati, Ohio': { latitude: 39.1031, longitude: -84.5120 },
  'Azusa, California': { latitude: 34.1336, longitude: -117.9076 },
  'West Hollywood, California': { latitude: 34.0900, longitude: -118.3617 },
  'Worcester, Massachusetts': { latitude: 42.2626, longitude: -71.8023 },
  'Dallas, Texas': { latitude: 32.7767, longitude: -96.7970 },
  'Milwaukee, Wisconsin': { latitude: 43.0389, longitude: -87.9065 },
  'Hudson, Wisconsin': { latitude: 44.9744, longitude: -92.7569 },
  'Cayey, Puerto Rico': { latitude: 18.1119, longitude: -66.1660 },
  'Iowa City, Iowa': { latitude: 41.6611, longitude: -91.5302 },
  'Tucson, Arizona': { latitude: 32.2226, longitude: -110.9747 },
  'Redlands, California': { latitude: 34.0556, longitude: -117.1825 },
  'Shreveport, Louisiana': { latitude: 32.5252, longitude: -93.7502 },
  'Savannah, Georgia': { latitude: 32.0809, longitude: -81.0912 },
  'Gloucester, Massachusetts': { latitude: 42.6159, longitude: -70.6620 },
  'Riverdale, Georgia': { latitude: 33.5726, longitude: -84.4133 },
  'Echo Park, California': { latitude: 34.0781, longitude: -118.2606 },
  'Austin, Texas': { latitude: 30.2672, longitude: -97.7431 },
  'Johnson City, Tennessee': { latitude: 36.3134, longitude: -82.3535 },
  'London, United Kingdom': { latitude: 51.5074, longitude: -0.1278 },
  'Nashville, Tennessee': { latitude: 36.1627, longitude: -86.7816 },
  'Kansas City, Missouri': { latitude: 39.0997, longitude: -94.5786 },
  'Indianapolis, Indiana': { latitude: 39.7684, longitude: -86.1581 },
  'Albuquerque, New Mexico': { latitude: 35.0844, longitude: -106.6504 },
  'Denver, Colorado': { latitude: 39.7392, longitude: -104.9903 },
  'Cherry Hill, New Jersey': { latitude: 39.9346, longitude: -75.0307 },
  'Springfield, Missouri': { latitude: 37.2090, longitude: -93.2923 },
  'Ramseur, North Carolina': { latitude: 35.7332, longitude: -79.6531 },
  'Acworth, Georgia': { latitude: 34.0662, longitude: -84.6769 },
  'Utica, Minnesota': { latitude: 43.9783, longitude: -91.9571 },
  'Phoenix, Arizona': { latitude: 33.4484, longitude: -112.0740 },
  'Sacramento, California': { latitude: 38.5816, longitude: -121.4944 },
  'Fresno, California': { latitude: 36.7378, longitude: -119.7871 },
  'Fayetteville, Arkansas': { latitude: 36.0626, longitude: -94.1574 },
  'Grand Rapids, Michigan': { latitude: 42.9634, longitude: -85.6681 },
  'Cataño, Puerto Rico': { latitude: 18.4413, longitude: -66.1307 },
  'East Orange, New Jersey': { latitude: 40.7673, longitude: -74.2049 },
  'Houston, Texas': { latitude: 29.7604, longitude: -95.3698 },
  'Ansonia, Connecticut': { latitude: 41.3462, longitude: -73.0790 },
  'Miami, Florida': { latitude: 25.7617, longitude: -80.1918 },
  'Darien, Connecticut': { latitude: 41.0787, longitude: -73.4693 },
  'Hartford, Connecticut': { latitude: 41.7658, longitude: -72.6734 },
  'West Hartford, Connecticut': { latitude: 41.7620, longitude: -72.7420 },
  'Philadelphia, Pennsylvania': { latitude: 39.9526, longitude: -75.1652 },
  'Brownsville, Texas': { latitude: 25.9017, longitude: -97.4975 },
  'Guaynabo, Puerto Rico': { latitude: 18.3575, longitude: -66.1108 },
  'Carolina, Puerto Rico': { latitude: 18.3808, longitude: -65.9574 },
  'Louisville, Kentucky': { latitude: 38.2527, longitude: -85.7585 },
  'Leeds, Alabama': { latitude: 33.5484, longitude: -86.5444 },
  'Asbury Park, New Jersey': { latitude: 40.2204, longitude: -74.0121 },
  'Chattanooga, Tennessee': { latitude: 35.0456, longitude: -85.3097 },
  'Columbus, Ohio': { latitude: 39.9612, longitude: -82.9988 },
};

export const contestants: Contestant[] = [
  // Season 1
  {
    id: 'bebe-zahara-benet',
    name: 'BeBe Zahara Benet',
    season: 1,
    finishingPosition: 1,
    ageAtShow: 28,
    hometown: 'Minneapolis, Minnesota',
    hometownCoordinates: cityCoordinates['Minneapolis, Minnesota'],
    headshotUrl: '/images/headshots/bebe-zahara-benet.webp',
    entranceQuote: '****, nice to meet you!',
    farewellQuote: 'n/a',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'bebezahara'
  },
  {
    id: 'nina-flowers',
    name: 'Nina Flowers',
    season: 1,
    finishingPosition: 2,
    ageAtShow: 34,
    hometown: 'Bayamón, Puerto Rico',
    hometownCoordinates: cityCoordinates['Bayamón, Puerto Rico'],
    headshotUrl: '/images/headshots/nina-flowers.webp',
    entranceQuote: 'Hi',
    farewellQuote: 'n/a',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'djninaflowers'
  },
  {
    id: 'rebecca-glasscock',
    name: 'Rebecca Glasscock',
    season: 1,
    finishingPosition: 3,
    ageAtShow: 26,
    hometown: 'Fort Lauderdale, Florida',
    hometownCoordinates: cityCoordinates['Fort Lauderdale, Florida'],
    headshotUrl: '/images/headshots/rebecca-glasscock.webp',
    entranceQuote: 'Hello, what\'s up?',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'the_javier_rivera'
  },
  {
    id: 'shannel',
    name: 'Shannel',
    season: 1,
    finishingPosition: 4,
    ageAtShow: 29,
    hometown: 'Las Vegas, Nevada',
    hometownCoordinates: cityCoordinates['Las Vegas, Nevada'],
    headshotUrl: '/images/headshots/shannel.webp',
    entranceQuote: 'Wooh, my God! Look at this! Wow, crazy, crazy, crazy!',
    farewellQuote: 'n/a',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'theofficialshannel'
  },
  {
    id: 'ongina',
    name: 'Ongina',
    season: 1,
    finishingPosition: 5,
    ageAtShow: 26,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/ongina.webp',
    entranceQuote: 'Hi, you guys are fabulous',
    farewellQuote: 'n/a',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'ongina'
  },
  {
    id: 'jade-s1',
    name: 'Jade',
    season: 1,
    finishingPosition: 6,
    ageAtShow: 25,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/jade-s1.webp',
    entranceQuote: 'Hi',
    farewellQuote: 'n/a',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'jadesotomayor'
  },
  {
    id: 'akashia',
    name: 'Akashia',
    season: 1,
    finishingPosition: 7,
    ageAtShow: 23,
    hometown: 'Cleveland, Ohio',
    hometownCoordinates: cityCoordinates['Cleveland, Ohio'],
    headshotUrl: '/images/headshots/akashia.webp',
    entranceQuote: 'Ow!',
    farewellQuote: 'n/a',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'akaboreal'
  },
  {
    id: 'tammie-brown',
    name: 'Tammie Brown',
    season: 1,
    finishingPosition: 8,
    ageAtShow: 28,
    hometown: 'Glen Burnie, Maryland',
    hometownCoordinates: cityCoordinates['Glen Burnie, Maryland'],
    headshotUrl: '/images/headshots/tammie-brown.webp',
    entranceQuote: '👍',
    farewellQuote: 'n/a',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'planettammie'
  },
  {
    id: 'victoria-porkchop-parker',
    name: 'Victoria "Porkchop" Parker',
    season: 1,
    finishingPosition: 9,
    ageAtShow: 39,
    hometown: 'Raleigh, North Carolina',
    hometownCoordinates: cityCoordinates['Raleigh, North Carolina'],
    headshotUrl: '/images/headshots/victoria-porkchop-parker.webp',
    entranceQuote: 'Hey girls, what\'s going on?',
    farewellQuote: 'n/a',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'porkchopla'
  },

  // Season 2
  {
    id: 'tyra-sanchez',
    name: 'Tyra Sanchez',
    season: 2,
    finishingPosition: 1,
    ageAtShow: 21,
    hometown: 'Orlando, Florida',
    hometownCoordinates: cityCoordinates['Orlando, Florida'],
    headshotUrl: '/images/headshots/tyra-sanchez.webp',
    entranceQuote: '(walks in)',
    farewellQuote: 'n/a',
    snatchGameCharacter: 'Beyoncé'
  },
  {
    id: 'raven',
    name: 'Raven',
    season: 2,
    finishingPosition: 2,
    ageAtShow: 30,
    hometown: 'Riverside, California',
    hometownCoordinates: cityCoordinates['Riverside, California'],
    headshotUrl: '/images/headshots/raven.webp',
    entranceQuote: 'What\'s up bitches?',
    farewellQuote: '',
    snatchGameCharacter: 'Paris Hilton',
    instagramHandle: 'ravenhuntys'
  },
  {
    id: 'jujubee',
    name: 'Jujubee',
    season: 2,
    finishingPosition: 3,
    ageAtShow: 25,
    hometown: 'Boston, Massachusetts',
    hometownCoordinates: cityCoordinates['Boston, Massachusetts'],
    headshotUrl: '/images/headshots/jujubee.webp',
    entranceQuote: 'What a sin!',
    farewellQuote: '',
    snatchGameCharacter: 'Kimora Lee Simmons',
    instagramHandle: 'jujubeeonline'
  },
  {
    id: 'tatianna',
    name: 'Tatianna',
    season: 2,
    finishingPosition: 4,
    ageAtShow: 21,
    hometown: 'Falls Church, Virginia',
    hometownCoordinates: cityCoordinates['Falls Church, Virginia'],
    headshotUrl: '/images/headshots/tatianna.webp',
    entranceQuote: '(walks in)',
    farewellQuote: '',
    snatchGameCharacter: 'Britney Spears',
    instagramHandle: 'tatiannagram'
  },
  {
    id: 'pandora-boxx',
    name: 'Pandora Boxx',
    season: 2,
    finishingPosition: 5,
    ageAtShow: 37,
    hometown: 'Rochester, New York',
    hometownCoordinates: cityCoordinates['Rochester, New York'],
    headshotUrl: '/images/headshots/pandora-boxx.webp',
    entranceQuote: 'Hey fake ladies!',
    farewellQuote: '',
    snatchGameCharacter: 'Carol Channing',
    instagramHandle: 'pandoraboxx'
  },
  {
    id: 'jessica-wild',
    name: 'Jessica Wild',
    season: 2,
    finishingPosition: 6,
    ageAtShow: 29,
    hometown: 'San Juan, Puerto Rico',
    hometownCoordinates: cityCoordinates['San Juan, Puerto Rico'],
    headshotUrl: '/images/headshots/jessica-wild.webp',
    entranceQuote: 'Oh my God!',
    farewellQuote: '',
    snatchGameCharacter: 'RuPaul',
    instagramHandle: 'jessicawild'
  },
  {
    id: 'sahara-davenport',
    name: 'Sahara Davenport',
    season: 2,
    finishingPosition: 7,
    ageAtShow: 25,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/sahara-davenport.webp',
    entranceQuote: '(screaming)',
    farewellQuote: '',
    snatchGameCharacter: 'Whitney Houston'
  },
  {
    id: 'morgan-mcmichaels',
    name: 'Morgan McMichaels',
    season: 2,
    finishingPosition: 8,
    ageAtShow: 28,
    hometown: 'Scotland Neck, North Carolina',
    hometownCoordinates: cityCoordinates['Scotland Neck, North Carolina'],
    headshotUrl: '/images/headshots/morgan-mcmichaels.webp',
    entranceQuote: 'Bitch!',
    farewellQuote: '',
    snatchGameCharacter: 'P!nk',
    instagramHandle: 'morganmcmichaels'
  },
  {
    id: 'sonique',
    name: 'Sonique',
    season: 2,
    finishingPosition: 9,
    ageAtShow: 26,
    hometown: 'Atlanta, Georgia',
    hometownCoordinates: cityCoordinates['Atlanta, Georgia'],
    headshotUrl: '/images/headshots/sonique.webp',
    entranceQuote: '(walks in)',
    farewellQuote: '',
    snatchGameCharacter: 'Lady Gaga',
    instagramHandle: 'xosonique'
  },
  {
    id: 'mystique-summers-madison',
    name: 'Mystique Summers Madison',
    season: 2,
    finishingPosition: 10,
    ageAtShow: 25,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/mystique-summers-madison.webp',
    entranceQuote: 'I\'m ****',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'mystiquesummers'
  },
  {
    id: 'nicole-paige-brooks',
    name: 'Nicole Paige Brooks',
    season: 2,
    finishingPosition: 11,
    ageAtShow: 36,
    hometown: 'Atlanta, Georgia',
    hometownCoordinates: cityCoordinates['Atlanta, Georgia'],
    headshotUrl: '/images/headshots/nicole-paige-brooks.webp',
    entranceQuote: 'Holy shit. I\'m first',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'thenicolepaigebrooks'
  },
  {
    id: 'shangela',
    name: 'Shangela',
    season: 2,
    finishingPosition: 12,
    ageAtShow: 28,
    hometown: 'Paris, Texas',
    hometownCoordinates: cityCoordinates['Paris, Texas'],
    headshotUrl: '/images/headshots/shangela.webp',
    entranceQuote: 'Hello somebody!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'itsshangela'
  },

  // Season 3
  {
    id: 'raja',
    name: 'Raja',
    season: 3,
    finishingPosition: 1,
    ageAtShow: 36,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/raja.webp',
    entranceQuote: '(no words)',
    farewellQuote: '',
    snatchGameCharacter: 'Tyra Banks',
    instagramHandle: 'sutanamrull'
  },
  {
    id: 'manila-luzon',
    name: 'Manila Luzon',
    season: 3,
    finishingPosition: 2,
    ageAtShow: 28,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/manila-luzon.webp',
    entranceQuote: 'Hellooo!',
    farewellQuote: '',
    snatchGameCharacter: 'Imelda Marcos',
    instagramHandle: 'manilaluzon'
  },
  {
    id: 'alexis-mateo',
    name: 'Alexis Mateo',
    season: 3,
    finishingPosition: 3,
    ageAtShow: 30,
    hometown: 'St. Petersburg, Florida',
    hometownCoordinates: cityCoordinates['St. Petersburg, Florida'],
    headshotUrl: '/images/headshots/alexis-mateo.webp',
    entranceQuote: 'Hey, hey, hey! How\'s everybody doing?',
    farewellQuote: '',
    snatchGameCharacter: 'Alicia Keys',
    instagramHandle: 'alexismateoofficial'
  },
  {
    id: 'yara-sofia',
    name: 'Yara Sofia',
    season: 3,
    finishingPosition: 4,
    ageAtShow: 26,
    hometown: 'Manati, Puerto Rico',
    hometownCoordinates: cityCoordinates['Manati, Puerto Rico'],
    headshotUrl: '/images/headshots/yara-sofia.webp',
    entranceQuote: 'Hi',
    farewellQuote: '',
    snatchGameCharacter: 'Amy Winehouse',
    instagramHandle: 'yarasofiapr'
  },
  {
    id: 'carmen-carrera',
    name: 'Carmen Carrera',
    season: 3,
    finishingPosition: 5,
    ageAtShow: 25,
    hometown: 'Elmwood Park, New Jersey',
    hometownCoordinates: cityCoordinates['Elmwood Park, New Jersey'],
    headshotUrl: '/images/headshots/carmen-carrera.webp',
    entranceQuote: '(walks in)',
    farewellQuote: '',
    snatchGameCharacter: 'Jennifer Lopez',
    instagramHandle: 'carmen_carrera'
  },
  {
    id: 'delta-work',
    name: 'Delta Work',
    season: 3,
    finishingPosition: 7,
    ageAtShow: 34,
    hometown: 'Norwalk, California',
    hometownCoordinates: cityCoordinates['Norwalk, California'],
    headshotUrl: '/images/headshots/delta-work.webp',
    entranceQuote: '(walks in)',
    farewellQuote: '',
    snatchGameCharacter: 'Cher',
    instagramHandle: 'deltawork'
  },
  {
    id: 'stacy-layne-matthews',
    name: 'Stacy Layne Matthews',
    season: 3,
    finishingPosition: 8,
    ageAtShow: 25,
    hometown: 'Back Swamp, North Carolina',
    hometownCoordinates: cityCoordinates['Back Swamp, North Carolina'],
    headshotUrl: '/images/headshots/stacy-layne-matthews.webp',
    entranceQuote: 'Hi',
    farewellQuote: '',
    snatchGameCharacter: 'Mo\'Nique',
    instagramHandle: 'stacylmatthews'
  },
  {
    id: 'mariah',
    name: 'Mariah',
    season: 3,
    finishingPosition: 9,
    ageAtShow: 29,
    hometown: 'Atlanta, Georgia',
    hometownCoordinates: cityCoordinates['Atlanta, Georgia'],
    headshotUrl: '/images/headshots/mariah.webp',
    entranceQuote: 'Hey',
    farewellQuote: '',
    snatchGameCharacter: 'Joan Crawford',
    instagramHandle: 'mug4dayz'
  },
  {
    id: 'india-ferrah',
    name: 'India Ferrah',
    season: 3,
    finishingPosition: 10,
    ageAtShow: 23,
    hometown: 'Dayton, Ohio',
    hometownCoordinates: cityCoordinates['Dayton, Ohio'],
    headshotUrl: '/images/headshots/india-ferrah.webp',
    entranceQuote: 'Prison honey',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'indiaferrah'
  },
  {
    id: 'mimi-imfurst',
    name: 'Mimi Imfurst',
    season: 3,
    finishingPosition: 11,
    ageAtShow: 27,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/mimi-imfurst.webp',
    entranceQuote: 'Welcome to my party! I brought cookies!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'mimiimfurst'
  },
  {
    id: 'phoenix',
    name: 'Phoenix',
    season: 3,
    finishingPosition: 12,
    ageAtShow: 29,
    hometown: 'Atlanta, Georgia',
    hometownCoordinates: cityCoordinates['Atlanta, Georgia'],
    headshotUrl: '/images/headshots/phoenix.webp',
    entranceQuote: 'Hi, what\'s going on?',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'phoenix_atl'
  },
  {
    id: 'venus-d-lite',
    name: 'Venus D-Lite',
    season: 3,
    finishingPosition: 13,
    ageAtShow: 26,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/venus-d-lite.webp',
    entranceQuote: 'Hello',
    farewellQuote: '',
    snatchGameCharacter: 'n/a'
  },

  // Season 4
  {
    id: 'sharon-needles',
    name: 'Sharon Needles',
    season: 4,
    finishingPosition: 1,
    ageAtShow: 29,
    hometown: 'Pittsburgh, Pennsylvania',
    hometownCoordinates: cityCoordinates['Pittsburgh, Pennsylvania'],
    headshotUrl: '/images/headshots/sharon-needles.webp',
    entranceQuote: 'I look spooky, but I\'m really nice!',
    farewellQuote: '',
    snatchGameCharacter: 'Michelle Visage',
    instagramHandle: 'sharonneedlespgh'
  },
  {
    id: 'chad-michaels',
    name: 'Chad Michaels',
    season: 4,
    finishingPosition: 2,
    ageAtShow: 40,
    hometown: 'San Diego, California',
    hometownCoordinates: cityCoordinates['San Diego, California'],
    headshotUrl: '/images/headshots/chad-michaels.webp',
    entranceQuote: 'Morning bitches!',
    farewellQuote: '',
    snatchGameCharacter: 'Cher',
    instagramHandle: 'chadmichaelsallstar'
  },
  {
    id: 'phi-phi-ohara',
    name: 'Phi Phi O\'Hara',
    season: 4,
    finishingPosition: 2,
    ageAtShow: 25,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/phi-phi-ohara.webp',
    entranceQuote: 'Well, hello, hello! How are y\'all doing?',
    farewellQuote: '',
    snatchGameCharacter: 'Lady Gaga'
  },
  {
    id: 'latrice-royale',
    name: 'Latrice Royale',
    season: 4,
    finishingPosition: 4,
    ageAtShow: 39,
    hometown: 'South Beach, Florida',
    hometownCoordinates: cityCoordinates['South Beach, Florida'],
    headshotUrl: '/images/headshots/latrice-royale.webp',
    entranceQuote: 'Eat it!',
    farewellQuote: '',
    snatchGameCharacter: 'Aretha Franklin',
    instagramHandle: 'latriceroyale'
  },
  {
    id: 'kenya-michaels',
    name: 'Kenya Michaels',
    season: 4,
    finishingPosition: 5,
    ageAtShow: 21,
    hometown: 'Dorado, Puerto Rico',
    hometownCoordinates: cityCoordinates['Dorado, Puerto Rico'],
    headshotUrl: '/images/headshots/kenya-michaels.webp',
    entranceQuote: 'Hi girls!',
    farewellQuote: '',
    snatchGameCharacter: 'Beyoncé'
  },
  {
    id: 'dida-ritz',
    name: 'DiDa Ritz',
    season: 4,
    finishingPosition: 6,
    ageAtShow: 25,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/dida-ritz.webp',
    entranceQuote: 'Bonjour ladies!',
    farewellQuote: '',
    snatchGameCharacter: 'Wendy Williams',
    instagramHandle: 'didaswag'
  },
  {
    id: 'willam',
    name: 'Willam',
    season: 4,
    finishingPosition: 7,
    ageAtShow: 29,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/willam.webp',
    entranceQuote: '(laughs)',
    farewellQuote: '',
    snatchGameCharacter: 'Jessica Simpson',
    instagramHandle: 'willam'
  },
  {
    id: 'jiggly-caliente',
    name: 'Jiggly Caliente',
    season: 4,
    finishingPosition: 8,
    ageAtShow: 30,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/jiggly-caliente.webp',
    entranceQuote: 'Hi ladies!',
    farewellQuote: '',
    snatchGameCharacter: 'Snooki'
  },
  {
    id: 'milan',
    name: 'Milan',
    season: 4,
    finishingPosition: 9,
    ageAtShow: 36,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/milan.webp',
    entranceQuote: 'Hey, there\'s a new girl in town! Let\'s get to business!',
    farewellQuote: '',
    snatchGameCharacter: 'Diana Ross',
    instagramHandle: 'itsdwaynecooper'
  },
  {
    id: 'madame-laqueer',
    name: 'Madame LaQueer',
    season: 4,
    finishingPosition: 10,
    ageAtShow: 29,
    hometown: 'Carolina, Puerto Rico',
    hometownCoordinates: cityCoordinates['Carolina, Puerto Rico'],
    headshotUrl: '/images/headshots/madame-laqueer.webp',
    entranceQuote: 'Hiya!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a'
  },
  {
    id: 'the-princess',
    name: 'The Princess',
    season: 4,
    finishingPosition: 11,
    ageAtShow: 32,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/the-princess.webp',
    entranceQuote: 'Hello!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'thedragprincess'
  },
  {
    id: 'lashauwn-beyond',
    name: 'Lashauwn Beyond',
    season: 4,
    finishingPosition: 12,
    ageAtShow: 21,
    hometown: 'Fort Lauderdale, Florida',
    hometownCoordinates: cityCoordinates['Fort Lauderdale, Florida'],
    headshotUrl: '/images/headshots/lashauwn-beyond.webp',
    entranceQuote: 'Hi queen one!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a'
  },
  {
    id: 'alisa-summers',
    name: 'Alisa Summers',
    season: 4,
    finishingPosition: 13,
    ageAtShow: 23,
    hometown: 'Tampa, Florida',
    hometownCoordinates: cityCoordinates['Tampa, Florida'],
    headshotUrl: '/images/headshots/alisa-summers.webp',
    entranceQuote: 'Hello, how y\'all doing?',
    farewellQuote: '',
    snatchGameCharacter: 'n/a'
  },

  // Season 5
  {
    id: 'jinkx-monsoon',
    name: 'Jinkx Monsoon',
    season: 5,
    finishingPosition: 1,
    ageAtShow: 24,
    hometown: 'Seattle, Washington',
    hometownCoordinates: cityCoordinates['Seattle, Washington'],
    headshotUrl: '/images/headshots/jinkx-monsoon.webp',
    entranceQuote: 'You know, I can hear the cackling from down the street!',
    farewellQuote: '',
    snatchGameCharacter: 'Little Edie',
    instagramHandle: 'thejinkx'
  },
  {
    id: 'alaska',
    name: 'Alaska',
    season: 5,
    finishingPosition: 2,
    ageAtShow: 27,
    hometown: 'Pittsburgh, Pennsylvania',
    hometownCoordinates: cityCoordinates['Pittsburgh, Pennsylvania'],
    headshotUrl: '/images/headshots/alaska.webp',
    entranceQuote: '(neighs) Hiiieeeee!',
    farewellQuote: '',
    snatchGameCharacter: 'Lady Bunny',
    instagramHandle: 'theonlyalaska5000'
  },
  {
    id: 'roxxxy-andrews',
    name: 'Roxxxy Andrews',
    season: 5,
    finishingPosition: 2,
    ageAtShow: 28,
    hometown: 'Orlando, Florida',
    hometownCoordinates: cityCoordinates['Orlando, Florida'],
    headshotUrl: '/images/headshots/roxxxy-andrews.webp',
    entranceQuote: 'Mash! Are you kidding?',
    farewellQuote: '',
    snatchGameCharacter: 'Tamar Braxton',
    instagramHandle: 'roxxxyandrews'
  },
  {
    id: 'detox',
    name: 'Detox',
    season: 5,
    finishingPosition: 4,
    ageAtShow: 27,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/detox.webp',
    entranceQuote: 'Holy shit, we\'re here!',
    farewellQuote: '',
    snatchGameCharacter: 'Ke$ha',
    instagramHandle: 'theonlydetox'
  },
  {
    id: 'coco-montrese',
    name: 'Coco Montrese',
    season: 5,
    finishingPosition: 5,
    ageAtShow: 37,
    hometown: 'Las Vegas, Nevada',
    hometownCoordinates: cityCoordinates['Las Vegas, Nevada'],
    headshotUrl: '/images/headshots/coco-montrese.webp',
    entranceQuote: 'Oh boys, the diva has arrived!',
    farewellQuote: '',
    snatchGameCharacter: 'Janet Jackson',
    instagramHandle: 'cocomontresediva'
  },
  {
    id: 'alyssa-edwards',
    name: 'Alyssa Edwards',
    season: 5,
    finishingPosition: 6,
    ageAtShow: 32,
    hometown: 'Mesquite, Texas',
    hometownCoordinates: cityCoordinates['Mesquite, Texas'],
    headshotUrl: '/images/headshots/alyssa-edwards.webp',
    entranceQuote: '(no words)',
    farewellQuote: '',
    snatchGameCharacter: 'Katy Perry',
    instagramHandle: 'alyssaedwards_1'
  },
  {
    id: 'ivy-winters',
    name: 'Ivy Winters',
    season: 5,
    finishingPosition: 7,
    ageAtShow: 26,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/ivy-winters.webp',
    entranceQuote: 'Hey hey hey ladies! Aahhhhh!',
    farewellQuote: '',
    snatchGameCharacter: 'Marilyn Monroe',
    instagramHandle: 'ivy_winters'
  },
  {
    id: 'jade-jolie',
    name: 'Jade Jolie',
    season: 5,
    finishingPosition: 8,
    ageAtShow: 25,
    hometown: 'Gainesville, Florida',
    hometownCoordinates: cityCoordinates['Gainesville, Florida'],
    headshotUrl: '/images/headshots/jade-jolie.webp',
    entranceQuote: 'Hey girls hey! What\'s going on pussycats?',
    farewellQuote: '',
    snatchGameCharacter: 'Taylor Swift',
    instagramHandle: 'missjadejolie'
  },
  {
    id: 'lineysha-sparx',
    name: 'Lineysha Sparx',
    season: 5,
    finishingPosition: 9,
    ageAtShow: 24,
    hometown: 'San Juan, Puerto Rico',
    hometownCoordinates: cityCoordinates['San Juan, Puerto Rico'],
    headshotUrl: '/images/headshots/lineysha-sparx.webp',
    entranceQuote: '(no words)',
    farewellQuote: '',
    snatchGameCharacter: 'Celia Cruz',
    instagramHandle: 'lineyshasparx'
  },
  {
    id: 'honey-mahogany',
    name: 'Honey Mahogany',
    season: 5,
    finishingPosition: 10,
    ageAtShow: 29,
    hometown: 'San Francisco, California',
    hometownCoordinates: cityCoordinates['San Francisco, California'],
    headshotUrl: '/images/headshots/honey-mahogany.webp',
    entranceQuote: 'Hey sisters!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'honeymahogany'
  },
  {
    id: 'vivienne-pinay',
    name: 'Vivienne Pinay',
    season: 5,
    finishingPosition: 10,
    ageAtShow: 26,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/vivienne-pinay.webp',
    entranceQuote: 'Hey y\'all!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'viviennepinay'
  },
  {
    id: 'monica-beverly-hillz',
    name: 'Monica Beverly Hillz',
    season: 5,
    finishingPosition: 12,
    ageAtShow: 27,
    hometown: 'Owensboro, Kentucky',
    hometownCoordinates: cityCoordinates['Owensboro, Kentucky'],
    headshotUrl: '/images/headshots/monica-beverly-hillz.webp',
    entranceQuote: 'Hello girls.',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'monicabhillz'
  },
  {
    id: 'serena-chacha',
    name: 'Serena ChaCha',
    season: 5,
    finishingPosition: 13,
    ageAtShow: 21,
    hometown: 'Tallahassee, Florida',
    hometownCoordinates: cityCoordinates['Tallahassee, Florida'],
    headshotUrl: '/images/headshots/serena-chacha.webp',
    entranceQuote: 'This is the best quinceanera present ever!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'myron.morgan'
  },
  {
    id: 'penny-tration',
    name: 'Penny Tration',
    season: 5,
    finishingPosition: 14,
    ageAtShow: 39,
    hometown: 'Cincinnati, Ohio',
    hometownCoordinates: cityCoordinates['Cincinnati, Ohio'],
    headshotUrl: '/images/headshots/penny-tration.webp',
    entranceQuote: 'Hello boys!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'misspennytration'
  },

  // Season 6
  {
    id: 'bianca-del-rio',
    name: 'Bianca Del Rio',
    season: 6,
    finishingPosition: 1,
    ageAtShow: 37,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/bianca-del-rio.webp',
    entranceQuote: 'Well well well, I hope you bitches are ready.',
    farewellQuote: '',
    snatchGameCharacter: 'Judge Judy',
    instagramHandle: 'thebiancadelrio'
  },
  {
    id: 'adore-delano',
    name: 'Adore Delano',
    season: 6,
    finishingPosition: 2,
    ageAtShow: 23,
    hometown: 'Azusa, California',
    hometownCoordinates: cityCoordinates['Azusa, California'],
    headshotUrl: '/images/headshots/adore-delano.webp',
    entranceQuote: 'I\'m home! Fuck yeah, I\'m the first one!',
    farewellQuote: '',
    snatchGameCharacter: 'Anna Nicole Smith',
    instagramHandle: 'adoredelano'
  },
  {
    id: 'courtney-act',
    name: 'Courtney Act',
    season: 6,
    finishingPosition: 2,
    ageAtShow: 31,
    hometown: 'West Hollywood, California',
    hometownCoordinates: cityCoordinates['West Hollywood, California'],
    headshotUrl: '/images/headshots/courtney-act.webp',
    entranceQuote: 'Is this America\'s Next Top Model? Oh, sorry… just kidding!',
    farewellQuote: '',
    snatchGameCharacter: 'Fran Drescher',
    instagramHandle: 'courtneyact'
  },
  {
    id: 'darienne-lake',
    name: 'Darienne Lake',
    season: 6,
    finishingPosition: 4,
    ageAtShow: 41,
    hometown: 'Rochester, New York',
    hometownCoordinates: cityCoordinates['Rochester, New York'],
    headshotUrl: '/images/headshots/darienne-lake.webp',
    entranceQuote: 'They better widen the doorways and reinforce the runways, because the big girl\'s in the house!',
    farewellQuote: '',
    snatchGameCharacter: 'Paula Deen',
    instagramHandle: 'dariennelake'
  },
  {
    id: 'bendelacreme',
    name: 'BenDeLaCreme',
    season: 6,
    finishingPosition: 5,
    ageAtShow: 31,
    hometown: 'Seattle, Washington',
    hometownCoordinates: cityCoordinates['Seattle, Washington'],
    headshotUrl: '/images/headshots/bendelacreme.webp',
    entranceQuote: 'Hi everybody, it\'s me, ****! Ooh, there\'s one!',
    farewellQuote: '',
    snatchGameCharacter: 'Maggie Smith',
    instagramHandle: 'bendelacreme'
  },
  {
    id: 'joslyn-fox',
    name: 'Joslyn Fox',
    season: 6,
    finishingPosition: 6,
    ageAtShow: 26,
    hometown: 'Worcester, Massachusetts',
    hometownCoordinates: cityCoordinates['Worcester, Massachusetts'],
    headshotUrl: '/images/headshots/joslyn-fox.webp',
    entranceQuote: '(laughs)',
    farewellQuote: '',
    snatchGameCharacter: 'Teresa Giudice',
    instagramHandle: 'joslynfox'
  },
  {
    id: 'trinity-k-bonet',
    name: 'Trinity K. Bonet',
    season: 6,
    finishingPosition: 7,
    ageAtShow: 22,
    hometown: 'Atlanta, Georgia',
    hometownCoordinates: cityCoordinates['Atlanta, Georgia'],
    headshotUrl: '/images/headshots/trinity-k-bonet.webp',
    entranceQuote: 'Hi',
    farewellQuote: '',
    snatchGameCharacter: 'Nicki Minaj',
    instagramHandle: 'trinitykbonet'
  },
  {
    id: 'laganja-estranja',
    name: 'Laganja Estranja',
    season: 6,
    finishingPosition: 8,
    ageAtShow: 24,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/laganja-estranja.webp',
    entranceQuote: 'Oh, y\'all wanted a twist, ey? Come on Season *, let\'s get sickening! Yassss!',
    farewellQuote: '',
    snatchGameCharacter: 'Rachel Zoe',
    instagramHandle: 'laganjaestranja'
  },
  {
    id: 'milk',
    name: 'Milk',
    season: 6,
    finishingPosition: 9,
    ageAtShow: 25,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/milk.webp',
    entranceQuote: '****! She does a body good, girl!',
    farewellQuote: '',
    snatchGameCharacter: 'Julia Child',
    instagramHandle: 'bigandmilky'
  },
  {
    id: 'gia-gunn',
    name: 'Gia Gunn',
    season: 6,
    finishingPosition: 10,
    ageAtShow: 23,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/gia-gunn.webp',
    entranceQuote: '(no words)',
    farewellQuote: '',
    snatchGameCharacter: 'Kim Kardashian',
    instagramHandle: 'gia_gunn'
  },
  {
    id: 'april-carrion',
    name: 'April Carrión',
    season: 6,
    finishingPosition: 11,
    ageAtShow: 24,
    hometown: 'Guaynabo, Puerto Rico',
    hometownCoordinates: cityCoordinates['Guaynabo, Puerto Rico'],
    headshotUrl: '/images/headshots/april-carrion.webp',
    entranceQuote: 'Reporting for duty, **** is in the house!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'aprilcarrion'
  },
  {
    id: 'vivacious',
    name: 'Vivacious',
    season: 6,
    finishingPosition: 12,
    ageAtShow: 40,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/vivacious.webp',
    entranceQuote: 'Mother has arrived!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'vivaciousnyc'
  },
  {
    id: 'kelly-mantle',
    name: 'Kelly Mantle',
    season: 6,
    finishingPosition: 14,
    ageAtShow: 37,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/kelly-mantle.webp',
    entranceQuote: 'Hey bitches, y\'all ready to rock and roll? Woooh!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'kellymantle'
  },
  {
    id: 'magnolia-crawford',
    name: 'Magnolia Crawford',
    season: 6,
    finishingPosition: 13,
    ageAtShow: 27,
    hometown: 'Seattle, Washington',
    hometownCoordinates: cityCoordinates['Seattle, Washington'],
    headshotUrl: '/images/headshots/magnolia-crawford.webp',
    entranceQuote: 'Oh wow!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a'
  },

  // Season 7
  {
    id: 'violet-chachki',
    name: 'Violet Chachki',
    season: 7,
    finishingPosition: 1,
    ageAtShow: 22,
    hometown: 'Atlanta, Georgia',
    hometownCoordinates: cityCoordinates['Atlanta, Georgia'],
    headshotUrl: '/images/headshots/violet-chachki.webp',
    entranceQuote: 'Ooh la la la la la la la la',
    farewellQuote: '',
    snatchGameCharacter: 'Alyssa Edwards',
    instagramHandle: 'violetchachki'
  },
  {
    id: 'ginger-minj',
    name: 'Ginger Minj',
    season: 7,
    finishingPosition: 2,
    ageAtShow: 29,
    hometown: 'Orlando, Florida',
    hometownCoordinates: cityCoordinates['Orlando, Florida'],
    headshotUrl: '/images/headshots/ginger-minj.webp',
    entranceQuote: 'Hi fellas!',
    farewellQuote: '',
    snatchGameCharacter: 'Adele',
    instagramHandle: 'gingerminj'
  },
  {
    id: 'pearl',
    name: 'Pearl',
    season: 7,
    finishingPosition: 2,
    ageAtShow: 23,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/pearl.webp',
    entranceQuote: 'Sup',
    farewellQuote: '',
    snatchGameCharacter: 'Big Ang',
    instagramHandle: 'pearliaison'
  },
  {
    id: 'kennedy-davenport',
    name: 'Kennedy Davenport',
    season: 7,
    finishingPosition: 4,
    ageAtShow: 33,
    hometown: 'Dallas, Texas',
    hometownCoordinates: cityCoordinates['Dallas, Texas'],
    headshotUrl: '/images/headshots/kennedy-davenport.webp',
    entranceQuote: 'Well hello!',
    farewellQuote: '',
    snatchGameCharacter: 'Little Richard',
    instagramHandle: 'kennedyddoftx'
  },
  {
    id: 'katya',
    name: 'Katya',
    season: 7,
    finishingPosition: 5,
    ageAtShow: 32,
    hometown: 'Boston, Massachusetts',
    hometownCoordinates: cityCoordinates['Boston, Massachusetts'],
    headshotUrl: '/images/headshots/katya.webp',
    entranceQuote: 'Давай cезон семь!',
    farewellQuote: '',
    snatchGameCharacter: 'Suze Orman',
    instagramHandle: 'katya_zamo'
  },
  {
    id: 'trixie-mattel',
    name: 'Trixie Mattel',
    season: 7,
    finishingPosition: 6,
    ageAtShow: 26,
    hometown: 'Milwaukee, Wisconsin',
    hometownCoordinates: cityCoordinates['Milwaukee, Wisconsin'],
    headshotUrl: '/images/headshots/trixie-mattel.webp',
    entranceQuote: 'This isn\'t Maury Povich!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'trixiemattel'
  },
  {
    id: 'miss-fame',
    name: 'Miss Fame',
    season: 7,
    finishingPosition: 7,
    ageAtShow: 29,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/miss-fame.webp',
    entranceQuote: 'Greetings earth queens, I come in peace',
    farewellQuote: '',
    snatchGameCharacter: 'Donatella Versace',
    instagramHandle: 'missfamenyc'
  },
  {
    id: 'jaidynn-diore-fierce',
    name: 'Jaidynn Diore Fierce',
    season: 7,
    finishingPosition: 8,
    ageAtShow: 25,
    hometown: 'Nashville, Tennessee',
    hometownCoordinates: cityCoordinates['Nashville, Tennessee'],
    headshotUrl: '/images/headshots/jaidynn-diore-fierce.webp',
    entranceQuote: 'How y\'all doing?',
    farewellQuote: '',
    snatchGameCharacter: 'Raven-Symoné',
    instagramHandle: 'jaidynnfierce'
  },
  {
    id: 'max',
    name: 'Max',
    season: 7,
    finishingPosition: 9,
    ageAtShow: 22,
    hometown: 'Hudson, Wisconsin',
    hometownCoordinates: cityCoordinates['Hudson, Wisconsin'],
    headshotUrl: '/images/headshots/max.webp',
    entranceQuote: 'Well, it\'s about time!',
    farewellQuote: '',
    snatchGameCharacter: 'Sharon Needles'
  },
  {
    id: 'kandy-ho',
    name: 'Kandy Ho',
    season: 7,
    finishingPosition: 10,
    ageAtShow: 28,
    hometown: 'Cayey, Puerto Rico',
    hometownCoordinates: cityCoordinates['Cayey, Puerto Rico'],
    headshotUrl: '/images/headshots/kandy-ho.webp',
    entranceQuote: 'I hope you got a sweet tooth, because ****\'s in the motherfucking house!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'ho_kandy'
  },
  {
    id: 'mrs-kasha-davis',
    name: 'Mrs. Kasha Davis',
    season: 7,
    finishingPosition: 11,
    ageAtShow: 43,
    hometown: 'Rochester, New York',
    hometownCoordinates: cityCoordinates['Rochester, New York'],
    headshotUrl: '/images/headshots/mrs-kasha-davis.webp',
    entranceQuote: 'Hiya my honeys, I\'m home!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'mrskashadavis'
  },
  {
    id: 'jasmine-masters',
    name: 'Jasmine Masters',
    season: 7,
    finishingPosition: 12,
    ageAtShow: 37,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/jasmine-masters.webp',
    entranceQuote: 'I\'m here! We made it bitches!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'msjasminemasters'
  },
  {
    id: 'sasha-belle',
    name: 'Sasha Belle',
    season: 7,
    finishingPosition: 13,
    ageAtShow: 28,
    hometown: 'Iowa City, Iowa',
    hometownCoordinates: cityCoordinates['Iowa City, Iowa'],
    headshotUrl: '/images/headshots/sasha-belle.webp',
    entranceQuote: 'Hey it\'s me, say hello to my little friends!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'sashabelley'
  },
  {
    id: 'tempest-dujour',
    name: 'Tempest DuJour',
    season: 7,
    finishingPosition: 14,
    ageAtShow: 46,
    hometown: 'Tucson, Arizona',
    hometownCoordinates: cityCoordinates['Tucson, Arizona'],
    headshotUrl: '/images/headshots/tempest-dujour.webp',
    entranceQuote: 'Who\'s ready for some hot tuna casserole, \'cos Mama\'s home!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'tempestdujour'
  },

  // Season 8
  {
    id: 'bob-the-drag-queen',
    name: 'Bob the Drag Queen',
    season: 8,
    finishingPosition: 1,
    ageAtShow: 29,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/bob-the-drag-queen.webp',
    entranceQuote: '(no words)',
    farewellQuote: '',
    snatchGameCharacter: 'Uzo Aduba',
    instagramHandle: 'bobthedragqueen'
  },
  {
    id: 'kim-chi',
    name: 'Kim Chi',
    season: 8,
    finishingPosition: 2,
    ageAtShow: 27,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/kim-chi.webp',
    entranceQuote: 'I came to chop suey the competition',
    farewellQuote: '',
    snatchGameCharacter: 'Kim Jong Un',
    instagramHandle: 'kimchi_chic'
  },
  {
    id: 'naomi-smalls',
    name: 'Naomi Smalls',
    season: 8,
    finishingPosition: 2,
    ageAtShow: 21,
    hometown: 'Redlands, California',
    hometownCoordinates: cityCoordinates['Redlands, California'],
    headshotUrl: '/images/headshots/naomi-smalls.webp',
    entranceQuote: 'Check your lipstick before you come for me.',
    farewellQuote: '',
    snatchGameCharacter: 'Tiffany "New York" Pollard',
    instagramHandle: 'naomismalls'
  },
  {
    id: 'chi-chi-devayne',
    name: 'Chi Chi DeVayne',
    season: 8,
    finishingPosition: 4,
    ageAtShow: 30,
    hometown: 'Shreveport, Louisiana',
    hometownCoordinates: cityCoordinates['Shreveport, Louisiana'],
    headshotUrl: '/images/headshots/chi-chi-devayne.webp',
    entranceQuote: 'Laissez les bon temps roulez!',
    farewellQuote: '',
    snatchGameCharacter: 'Eartha Kitt'
  },
  {
    id: 'derrick-barry',
    name: 'Derrick Barry',
    season: 8,
    finishingPosition: 5,
    ageAtShow: 32,
    hometown: 'Las Vegas, Nevada',
    hometownCoordinates: cityCoordinates['Las Vegas, Nevada'],
    headshotUrl: '/images/headshots/derrick-barry.webp',
    entranceQuote: 'It\'s **** bitch',
    farewellQuote: '',
    snatchGameCharacter: 'Britney Spears',
    instagramHandle: 'derrickbarry'
  },
  {
    id: 'thorgy-thor',
    name: 'Thorgy Thor',
    season: 8,
    finishingPosition: 6,
    ageAtShow: 31,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/thorgy-thor.webp',
    entranceQuote: 'Wooh! **** with a ** and **** and I feel incredible!',
    farewellQuote: '',
    snatchGameCharacter: 'Michael Jackson',
    instagramHandle: 'thorgythor'
  },
  {
    id: 'robbie-turner',
    name: 'Robbie Turner',
    season: 8,
    finishingPosition: 7,
    ageAtShow: 33,
    hometown: 'Seattle, Washington',
    hometownCoordinates: cityCoordinates['Seattle, Washington'],
    headshotUrl: '/images/headshots/robbie-turner.webp',
    entranceQuote: 'Good morning, I didn\'t realise this was happening today',
    farewellQuote: '',
    snatchGameCharacter: 'Diana Vreeland',
    instagramHandle: 'therobbieturner'
  },
  {
    id: 'acid-betty',
    name: 'Acid Betty',
    season: 8,
    finishingPosition: 8,
    ageAtShow: 37,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/acid-betty.webp',
    entranceQuote: 'No need to adjust your TV sets, this acid trip is all real!',
    farewellQuote: '',
    snatchGameCharacter: 'Nancy Grace',
    instagramHandle: 'acidbetty'
  },
  {
    id: 'naysha-lopez',
    name: 'Naysha Lopez',
    season: 8,
    finishingPosition: 9,
    ageAtShow: 31,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/naysha-lopez.webp',
    entranceQuote: 'Ola, the beauty is here',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'nayshalopez'
  },
  {
    id: 'cynthia-lee-fontaine',
    name: 'Cynthia Lee Fontaine',
    season: 8,
    finishingPosition: 10,
    ageAtShow: 34,
    hometown: 'Austin, Texas',
    hometownCoordinates: cityCoordinates['Austin, Texas'],
    headshotUrl: '/images/headshots/cynthia-lee-fontaine.webp',
    entranceQuote: 'How ya doin mis amores? You wanna see my cucu?',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'cynthialeefontaine'
  },
  {
    id: 'dax-exclamationpoint',
    name: 'Dax ExclamationPoint',
    season: 8,
    finishingPosition: 11,
    ageAtShow: 31,
    hometown: 'Savannah, Georgia',
    hometownCoordinates: cityCoordinates['Savannah, Georgia'],
    headshotUrl: '/images/headshots/dax-eclamationpoint.webp',
    entranceQuote: 'What\'s up nerds?',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'daxclamation'
  },
  {
    id: 'laila-mcqueen',
    name: 'Laila McQueen',
    season: 8,
    finishingPosition: 11,
    ageAtShow: 22,
    hometown: 'Gloucester, Massachusetts',
    hometownCoordinates: cityCoordinates['Gloucester, Massachusetts'],
    headshotUrl: '/images/headshots/laila-mcqueen.webp',
    entranceQuote: 'Alright ladies, let\'s turn up the juice and see what shakes loose!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'misslailamcqueen'
  },

  // Season 9
  {
    id: 'sasha-velour',
    name: 'Sasha Velour',
    season: 9,
    finishingPosition: 1,
    ageAtShow: 29,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/sasha-velour.webp',
    entranceQuote: '(screaming)',
    farewellQuote: '',
    snatchGameCharacter: 'Marlene Dietrich',
    instagramHandle: 'sashavelour'
  },
  {
    id: 'peppermint',
    name: 'Peppermint',
    season: 9,
    finishingPosition: 2,
    ageAtShow: 37,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/peppermint.webp',
    entranceQuote: 'Oh my gosh! Heyyyy!',
    farewellQuote: '',
    snatchGameCharacter: 'NeNe Leakes',
    instagramHandle: 'peppermint247'
  },
  {
    id: 'shea-coulee',
    name: 'Shea Couleé',
    season: 9,
    finishingPosition: 3,
    ageAtShow: 27,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/shea-coulee.webp',
    entranceQuote: 'My name\'s ****, and I didn\'t come to play, I came to slay!',
    farewellQuote: '',
    snatchGameCharacter: 'Naomi Campbell',
    instagramHandle: 'sheacoulee'
  },
  {
    id: 'trinity-taylor',
    name: 'Trinity Taylor',
    season: 9,
    finishingPosition: 3,
    ageAtShow: 31,
    hometown: 'Orlando, Florida',
    hometownCoordinates: cityCoordinates['Orlando, Florida'],
    headshotUrl: '/images/headshots/trinity-taylor.webp',
    entranceQuote: 'The body is here bitches!',
    farewellQuote: '',
    snatchGameCharacter: 'Amanda Lepore',
    instagramHandle: 'trinitythetuck'
  },
  {
    id: 'alexis-michelle',
    name: 'Alexis Michelle',
    season: 9,
    finishingPosition: 5,
    ageAtShow: 33,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/alexis-michelle.webp',
    entranceQuote: 'How\'d ya like them egg rolls, Mr Charles?',
    farewellQuote: '',
    snatchGameCharacter: 'Liza Minnelli',
    instagramHandle: 'alexislives'
  },
  {
    id: 'nina-bonina-brown',
    name: 'Nina Bo\'nina Brown',
    season: 9,
    finishingPosition: 6,
    ageAtShow: 34,
    hometown: 'Riverdale, Georgia',
    hometownCoordinates: cityCoordinates['Riverdale, Georgia'],
    headshotUrl: '/images/headshots/nina-bonina-brown.webp',
    entranceQuote: 'I\'m ****, Banana, Fofana, Osama Bin Laden Brown, boom boom boom!',
    farewellQuote: '',
    snatchGameCharacter: 'Jasmine Masters'
  },
  {
    id: 'valentina',
    name: 'Valentina',
    season: 9,
    finishingPosition: 7,
    ageAtShow: 25,
    hometown: 'Echo Park, California',
    hometownCoordinates: cityCoordinates['Echo Park, California'],
    headshotUrl: '/images/headshots/valentina.webp',
    entranceQuote: 'Hello, it\'s me ****!',
    farewellQuote: '',
    snatchGameCharacter: 'Ariadna Gutiérrez',
    instagramHandle: 'allaboutvalentina'
  },
  {
    id: 'farrah-moan',
    name: 'Farrah Moan',
    season: 9,
    finishingPosition: 8,
    ageAtShow: 23,
    hometown: 'Las Vegas, Nevada',
    hometownCoordinates: cityCoordinates['Las Vegas, Nevada'],
    headshotUrl: '/images/headshots/farrah-moan.webp',
    entranceQuote: 'So this is what it looks like',
    farewellQuote: '',
    snatchGameCharacter: 'Gigi Gorgeous',
    instagramHandle: 'farrahrized'
  },
  {
    id: 'aja',
    name: 'Aja',
    season: 9,
    finishingPosition: 9,
    ageAtShow: 22,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/aja.webp',
    entranceQuote: 'Your edges are officially snatched',
    farewellQuote: '',
    snatchGameCharacter: 'Alyssa Edwards',
    instagramHandle: 'ajathekween'
  },
  {
    id: 'eureka',
    name: 'Eureka',
    season: 9,
    finishingPosition: 11,
    ageAtShow: 25,
    hometown: 'Johnson City, Tennessee',
    hometownCoordinates: cityCoordinates['Johnson City, Tennessee'],
    headshotUrl: '/images/headshots/eureka.webp',
    entranceQuote: 'Ow, come on, give it up for the big girl! Serving pure catfish.',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'eurekaohara'
  },
  {
    id: 'charlie-hides',
    name: 'Charlie Hides',
    season: 9,
    finishingPosition: 12,
    ageAtShow: 52,
    hometown: 'London, United Kingdom',
    hometownCoordinates: cityCoordinates['London, United Kingdom'],
    headshotUrl: '/images/headshots/charlie-hides.webp',
    entranceQuote: 'Hi hi hi, it\'s about to get shady up in here!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'charliehidestv'
  },
  {
    id: 'kimora-blac',
    name: 'Kimora Blac',
    season: 9,
    finishingPosition: 13,
    ageAtShow: 28,
    hometown: 'Las Vegas, Nevada',
    hometownCoordinates: cityCoordinates['Las Vegas, Nevada'],
    headshotUrl: '/images/headshots/kimora-blac.webp',
    entranceQuote: 'Is it me or is it hot in here?',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'kimorablac'
  },
  {
    id: 'jaymes-mansfield',
    name: 'Jaymes Mansfield',
    season: 9,
    finishingPosition: 14,
    ageAtShow: 26,
    hometown: 'Milwaukee, Wisconsin',
    hometownCoordinates: cityCoordinates['Milwaukee, Wisconsin'],
    headshotUrl: '/images/headshots/jaymes-mansfield.webp',
    entranceQuote: 'Hi shapeshifters!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'jaymesmansfield'
  },

  // Season 10
  {
    id: 'aquaria',
    name: 'Aquaria',
    season: 10,
    finishingPosition: 1,
    ageAtShow: 21,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/aquaria.webp',
    entranceQuote: 'Bonjour!',
    farewellQuote: '',
    snatchGameCharacter: 'Melania Trump',
    instagramHandle: 'ageofaquaria'
  },
  {
    id: 'kameron-michaels',
    name: 'Kameron Michaels',
    season: 10,
    finishingPosition: 2,
    ageAtShow: 31,
    hometown: 'Nashville, Tennessee',
    hometownCoordinates: cityCoordinates['Nashville, Tennessee'],
    headshotUrl: '/images/headshots/kameron-michaels.webp',
    entranceQuote: 'Well I auditioned for the Pit Crew, but this is gonna be way more fun!',
    farewellQuote: '',
    snatchGameCharacter: 'Chyna',
    instagramHandle: 'kameronmichaels'
  },
  {
    id: 'asia-ohara',
    name: 'Asia O\'Hara',
    season: 10,
    finishingPosition: 4,
    ageAtShow: 35,
    hometown: 'Dallas, Texas',
    hometownCoordinates: cityCoordinates['Dallas, Texas'],
    headshotUrl: '/images/headshots/asia-ohara.webp',
    entranceQuote: 'Well guys, Texas is back in the house',
    farewellQuote: '',
    snatchGameCharacter: 'Beyoncé'
  },
  {
    id: 'miz-cracker',
    name: 'Miz Cracker',
    season: 10,
    finishingPosition: 5,
    ageAtShow: 33,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/miz-cracker.webp',
    entranceQuote: 'Okay, it\'s time for dinner!',
    farewellQuote: '',
    snatchGameCharacter: 'Dorothy Parker',
    instagramHandle: 'mizcracker'
  },
  {
    id: 'monet-x-change',
    name: 'Monét X Change',
    season: 10,
    finishingPosition: 6,
    ageAtShow: 27,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/money-x-change.webp',
    entranceQuote: 'Oh don\'t mind me, I\'m just here to sweep up the competition girl!',
    farewellQuote: '',
    snatchGameCharacter: 'Maya Angelou',
    instagramHandle: 'monetxchange'
  },
  {
    id: 'the-vixen',
    name: 'The Vixen',
    season: 10,
    finishingPosition: 7,
    ageAtShow: 26,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/the-vixen.webp',
    entranceQuote: 'I\'m just here to fight!',
    farewellQuote: '',
    snatchGameCharacter: 'Blue Ivy Carter',
    instagramHandle: 'thevixensworld'
  },
  {
    id: 'monique-heart',
    name: 'Monique Heart',
    season: 10,
    finishingPosition: 8,
    ageAtShow: 31,
    hometown: 'Kansas City, Missouri',
    hometownCoordinates: cityCoordinates['Kansas City, Missouri'],
    headshotUrl: '/images/headshots/monique-heart.webp',
    entranceQuote: 'Ka-kitty-ka-kit-ka-ka-ka, ka-kitty-kat-kat-kow, giving you the heart of Season **, ****, the face',
    farewellQuote: '',
    snatchGameCharacter: 'Maxine Waters',
    instagramHandle: 'iammoheart'
  },
  {
    id: 'blair-st-clair',
    name: 'Blair St. Clair',
    season: 10,
    finishingPosition: 9,
    ageAtShow: 22,
    hometown: 'Indianapolis, Indiana',
    hometownCoordinates: cityCoordinates['Indianapolis, Indiana'],
    headshotUrl: '/images/headshots/blair-st-clair.webp',
    entranceQuote: 'I\'m ****, just got here this morning!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'blairstclair'
  },
  {
    id: 'mayhem-miller',
    name: 'Mayhem Miller',
    season: 10,
    finishingPosition: 10,
    ageAtShow: 35,
    hometown: 'Riverside, California',
    hometownCoordinates: cityCoordinates['Riverside, California'],
    headshotUrl: '/images/headshots/mayhem-miller.webp',
    entranceQuote: 'Guess who finally decided to crash the party?',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'theonlymayhem'
  },
  {
    id: 'dusty-ray-bottoms',
    name: 'Dusty Ray Bottoms',
    season: 10,
    finishingPosition: 11,
    ageAtShow: 29,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/dusty-ray-bottoms.webp',
    entranceQuote: 'Never loved ya',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'dustyray'
  },
  {
    id: 'yuhua-hamasaki',
    name: 'Yuhua Hamasaki',
    season: 10,
    finishingPosition: 12,
    ageAtShow: 27,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/yuhua-hamaski.webp',
    entranceQuote: 'Can you feel the shade?',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'yuhuahamasaki'
  },
  {
    id: 'kalorie-karbdashian-williams',
    name: 'Kalorie Karbdashian-Williams',
    season: 10,
    finishingPosition: 13,
    ageAtShow: 27,
    hometown: 'Albuquerque, New Mexico',
    hometownCoordinates: cityCoordinates['Albuquerque, New Mexico'],
    headshotUrl: '/images/headshots/kalorie-karbdashian-williams.webp',
    entranceQuote: 'Hope you\'re ready for your all-carb, high calorie diet',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'kalkarbdashianw'
  },
  {
    id: 'vanessa-vanjie-mateo',
    name: 'Vanessa Vanjie Mateo',
    season: 10,
    finishingPosition: 14,
    ageAtShow: 25,
    hometown: 'Tampa, Florida',
    hometownCoordinates: cityCoordinates['Tampa, Florida'],
    headshotUrl: '/images/headshots/vanessa-vanjie-mateo.webp',
    entranceQuote: '10s, 10s, 10s across the board!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'vanessavanjie'
  },

  // Season 11
  {
    id: 'yvie-oddly',
    name: 'Yvie Oddly',
    season: 11,
    finishingPosition: 1,
    ageAtShow: 24,
    hometown: 'Denver, Colorado',
    hometownCoordinates: cityCoordinates['Denver, Colorado'],
    headshotUrl: '/images/headshots/yvie-oddly.webp',
    entranceQuote: 'Move over ladies, this race just took an odd turn',
    farewellQuote: '',
    snatchGameCharacter: 'Whoopi Goldberg',
    instagramHandle: 'oddlyyvie'
  },
  {
    id: 'brooke-lynn-hytes',
    name: 'Brooke Lynn Hytes',
    season: 11,
    finishingPosition: 2,
    ageAtShow: 32,
    hometown: 'Nashville, Tennessee',
    hometownCoordinates: cityCoordinates['Nashville, Tennessee'],
    headshotUrl: '/images/headshots/brooke-lynn-hytes.webp',
    entranceQuote: 'Never fear, the queen of the North is here!',
    farewellQuote: '',
    snatchGameCharacter: 'Céline Dion',
    instagramHandle: 'bhytes'
  },
  {
    id: 'akeria-c-davenport',
    name: 'A\'keria C. Davenport',
    season: 11,
    finishingPosition: 3,
    ageAtShow: 30,
    hometown: 'Dallas, Texas',
    hometownCoordinates: cityCoordinates['Dallas, Texas'],
    headshotUrl: '/images/headshots/akeria-c-davenport.webp',
    entranceQuote: 'Oh yes it\'s me, Miss **** D-A-V-E-N-P-O-R and as you can see, I\'m the motherfucking T',
    farewellQuote: '',
    snatchGameCharacter: 'Tiffany Haddish'
  },
  {
    id: 'silky-nutmeg-ganache',
    name: 'Silky Nutmeg Ganache',
    season: 11,
    finishingPosition: 3,
    ageAtShow: 28,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/silky-nutmeg-ganache.webp',
    entranceQuote: 'Munch munch, crunch crunch, **** is here to eat the lunch',
    farewellQuote: '',
    snatchGameCharacter: 'Ts Madison',
    instagramHandle: 'silkyganache'
  },
  {
    id: 'nina-west',
    name: 'Nina West',
    season: 11,
    finishingPosition: 6,
    ageAtShow: 39,
    hometown: 'Columbus, Ohio',
    hometownCoordinates: cityCoordinates['Columbus, Ohio'],
    headshotUrl: '/images/headshots/nina-west.webp',
    entranceQuote: 'Welcome to Season **, it looks like things just got ****-gendary!',
    farewellQuote: '',
    snatchGameCharacter: 'Harvey Fierstein',
    instagramHandle: 'ninawest'
  },
  {
    id: 'shuga-cain',
    name: 'Shuga Cain',
    season: 11,
    finishingPosition: 7,
    ageAtShow: 40,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/shuga-cain.webp',
    entranceQuote: 'Get ready y\'all, because this sugar is so sweet!',
    farewellQuote: '',
    snatchGameCharacter: 'Charo',
    instagramHandle: 'missshugacain'
  },
  {
    id: 'plastique-tiara',
    name: 'Plastique Tiara',
    season: 11,
    finishingPosition: 8,
    ageAtShow: 21,
    hometown: 'Dallas, Texas',
    hometownCoordinates: cityCoordinates['Dallas, Texas'],
    headshotUrl: '/images/headshots/pastique-tiara.webp',
    entranceQuote: 'Hello, I\'m **** from Vietnam',
    farewellQuote: '',
    snatchGameCharacter: 'Lovely Mimi',
    instagramHandle: 'plastique'
  },
  {
    id: 'rajah-ohara',
    name: 'Ra\'Jah O\'Hara',
    season: 11,
    finishingPosition: 9,
    ageAtShow: 33,
    hometown: 'Dallas, Texas',
    hometownCoordinates: cityCoordinates['Dallas, Texas'],
    headshotUrl: '/images/headshots/rajah-ohara.webp',
    entranceQuote: 'Extra, extra, read all about it! **** is in the house, and I hope you came to play',
    farewellQuote: '',
    snatchGameCharacter: 'n/a'
  },
  {
    id: 'scarlet-envy',
    name: 'Scarlet Envy',
    season: 11,
    finishingPosition: 10,
    ageAtShow: 26,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/scarlet-envy.webp',
    entranceQuote: 'The world wants me, and the feeling is mutual',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'scarletenvy'
  },
  {
    id: 'ariel-versace',
    name: 'Ariel Versace',
    season: 11,
    finishingPosition: 11,
    ageAtShow: 26,
    hometown: 'Cherry Hill, New Jersey',
    hometownCoordinates: cityCoordinates['Cherry Hill, New Jersey'],
    headshotUrl: '/images/headshots/ariel-versace.webp',
    entranceQuote: 'Now this is what dreams are made of! Nyass!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'arielversace'
  },
  {
    id: 'mercedes-iman-diamond',
    name: 'Mercedes Iman Diamond',
    season: 11,
    finishingPosition: 12,
    ageAtShow: 31,
    hometown: 'Minneapolis, Minnesota',
    hometownCoordinates: cityCoordinates['Minneapolis, Minnesota'],
    headshotUrl: '/images/headshots/mercedes-iman-diamond.webp',
    entranceQuote: '(ululating)',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'mercedesimandiamond'
  },
  {
    id: 'honey-davenport',
    name: 'Honey Davenport',
    season: 11,
    finishingPosition: 13,
    ageAtShow: 32,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/honey-davenport.webp',
    entranceQuote: 'This honey is raw and unfiltered',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'honeydavenportofficial'
  },
  {
    id: 'kahanna-montrese',
    name: 'Kahanna Montrese',
    season: 11,
    finishingPosition: 14,
    ageAtShow: 25,
    hometown: 'Las Vegas, Nevada',
    hometownCoordinates: cityCoordinates['Las Vegas, Nevada'],
    headshotUrl: '/images/headshots/kahanna-montrese.webp',
    entranceQuote: 'Vegas is back in the house, and this time we\'re hitting the jackpot',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'kahannamontrese'
  },
  {
    id: 'soju',
    name: 'Soju',
    season: 11,
    finishingPosition: 15,
    ageAtShow: 27,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/soju.webp',
    entranceQuote: '(whacks around her nunchucks)',
    farewellQuote: '',
    snatchGameCharacter: 'n/a'
  },

  // Season 12
  {
    id: 'jaida-essence-hall',
    name: 'Jaida Essence Hall',
    season: 12,
    finishingPosition: 1,
    ageAtShow: 32,
    hometown: 'Milwaukee, Wisconsin',
    hometownCoordinates: cityCoordinates['Milwaukee, Wisconsin'],
    headshotUrl: '/images/headshots/jaida-essence-hall.webp',
    entranceQuote: 'Hey bitches! She\'s here!',
    farewellQuote: '',
    snatchGameCharacter: 'Cardi B',
    instagramHandle: 'jaidaehall'
  },
  {
    id: 'crystal-methyd',
    name: 'Crystal Methyd',
    season: 12,
    finishingPosition: 2,
    ageAtShow: 28,
    hometown: 'Springfield, Missouri',
    hometownCoordinates: cityCoordinates['Springfield, Missouri'],
    headshotUrl: '/images/headshots/crystal-methyd.webp',
    entranceQuote: 'Who\'s ready to party and play? Checkers anyone?',
    farewellQuote: '',
    snatchGameCharacter: 'Poppy',
    instagramHandle: 'crystalmethyd'
  },
  {
    id: 'gigi-goode',
    name: 'Gigi Goode',
    season: 12,
    finishingPosition: 2,
    ageAtShow: 21,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/gigi-goode.webp',
    entranceQuote: 'Ahoy',
    farewellQuote: '',
    snatchGameCharacter: 'Maria the Robot',
    instagramHandle: 'thegigigoode'
  },
  {
    id: 'jackie-cox',
    name: 'Jackie Cox',
    season: 12,
    finishingPosition: 5,
    ageAtShow: 34,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/jackie-cox.webp',
    entranceQuote: 'Roll call! I\'m ****, Salaam, the Persian Princess of Drag has arrived!',
    farewellQuote: '',
    snatchGameCharacter: 'Lisa Rinna',
    instagramHandle: 'jackiecoxnyc'
  },
  {
    id: 'heidi-n-closet',
    name: 'Heidi N Closet',
    season: 12,
    finishingPosition: 6,
    ageAtShow: 24,
    hometown: 'Ramseur, North Carolina',
    hometownCoordinates: cityCoordinates['Ramseur, North Carolina'],
    headshotUrl: '/images/headshots/heidi-n-closet.webp',
    entranceQuote: 'America, it\'s time to stop hiding in the closet',
    farewellQuote: '',
    snatchGameCharacter: 'Leslie Jones',
    instagramHandle: 'heidincloset'
  },
  {
    id: 'widow-vondu',
    name: 'Widow Von\'Du',
    season: 12,
    finishingPosition: 7,
    ageAtShow: 30,
    hometown: 'Kansas City, Missouri',
    hometownCoordinates: cityCoordinates['Kansas City, Missouri'],
    headshotUrl: '/images/headshots/widow-von-du.webp',
    entranceQuote: 'Relax your throat bitches, \'cos y\'all gagging',
    farewellQuote: '',
    snatchGameCharacter: 'Tina Turner / Ike Turner'
  },
  {
    id: 'jan',
    name: 'Jan',
    season: 12,
    finishingPosition: 8,
    ageAtShow: 26,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/jan.webp',
    entranceQuote: 'Hey y\'all, let\'s play some basketball!',
    farewellQuote: '',
    snatchGameCharacter: 'Bernardette Peters',
    instagramHandle: 'janjanjan'
  },
  {
    id: 'brita',
    name: 'Brita',
    season: 12,
    finishingPosition: 9,
    ageAtShow: 34,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/brita.webp',
    entranceQuote: 'Here we go, sis! Y\'all thirsty?',
    farewellQuote: '',
    snatchGameCharacter: 'Jennifer Holliday',
    instagramHandle: 'thebritafilter'
  },
  {
    id: 'aiden-zhane',
    name: 'Aiden Zhane',
    season: 12,
    finishingPosition: 10,
    ageAtShow: 29,
    hometown: 'Acworth, Georgia',
    hometownCoordinates: cityCoordinates['Acworth, Georgia'],
    headshotUrl: '/images/headshots/aiden-zhane.webp',
    entranceQuote: 'Season ** is about to be in-****',
    farewellQuote: '',
    snatchGameCharacter: 'Patricia Quinn',
    instagramHandle: 'aiden_zhane'
  },
  {
    id: 'nicky-doll',
    name: 'Nicky Doll',
    season: 12,
    finishingPosition: 11,
    ageAtShow: 28,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/nicky-doll.webp',
    entranceQuote: 'Well, that was a long flight',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'nickidoll'
  },
  {
    id: 'rock-m-sakura',
    name: 'Rock M. Sakura',
    season: 12,
    finishingPosition: 12,
    ageAtShow: 28,
    hometown: 'San Francisco, California',
    hometownCoordinates: cityCoordinates['San Francisco, California'],
    headshotUrl: '/images/headshots/rock-m-sakura.webp',
    entranceQuote: 'All tuck and no play make **** a crazy bitch!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'rockmsakura'
  },
  {
    id: 'dahlia-sin',
    name: 'Dahlia Sin',
    season: 12,
    finishingPosition: 13,
    ageAtShow: 28,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/dahlia-sin.webp',
    entranceQuote: 'Are you ready to live a little, sin a lot?',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'dahlia_sin'
  },

  // Season 13
  {
    id: 'symone',
    name: 'Symone',
    season: 13,
    finishingPosition: 1,
    ageAtShow: 25,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/symone.webp',
    entranceQuote: 'Don\'t let the smooth taste fool ya, baby!',
    farewellQuote: '',
    snatchGameCharacter: 'Harriet Tubman',
    instagramHandle: 'symone'
  },
  {
    id: 'kandy-muse',
    name: 'Kandy Muse',
    season: 13,
    finishingPosition: 2,
    ageAtShow: 25,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/kandy-muse.webp',
    entranceQuote: 'Girl! From the hood to Hollywood!',
    farewellQuote: '',
    snatchGameCharacter: 'Patrick Starrr',
    instagramHandle: 'kandymuse'
  },
  {
    id: 'gottmik',
    name: 'Gottmik',
    season: 13,
    finishingPosition: 3,
    ageAtShow: 23,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/gottmik.webp',
    entranceQuote: 'Time to crash the cis-tem',
    farewellQuote: '',
    snatchGameCharacter: 'Paris Hilton',
    instagramHandle: 'gottmik'
  },
  {
    id: 'rose',
    name: 'Rosé',
    season: 13,
    finishingPosition: 3,
    ageAtShow: 31,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/rose.webp',
    entranceQuote: 'Hey! Oh my god, I\'m the first one here. I could have gone to the dentist',
    farewellQuote: '',
    snatchGameCharacter: 'Mary, Queen of Scots',
    instagramHandle: 'omgitsrose'
  },
  {
    id: 'olivia-lux',
    name: 'Olivia Lux',
    season: 13,
    finishingPosition: 5,
    ageAtShow: 26,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/olivia-lux.webp',
    entranceQuote: '**** be a lady tonight',
    farewellQuote: '',
    snatchGameCharacter: 'Tabitha Brown',
    instagramHandle: 'olivialux'
  },
  {
    id: 'utica-queen',
    name: 'Utica Queen',
    season: 13,
    finishingPosition: 6,
    ageAtShow: 25,
    hometown: 'Utica, Minnesota',
    hometownCoordinates: cityCoordinates['Utica, Minnesota'],
    headshotUrl: '/images/headshots/utica.webp',
    entranceQuote: 'Ah-choo! She\'s sickening!',
    farewellQuote: '',
    snatchGameCharacter: 'Bob Ross',
    instagramHandle: 'queenutica'
  },
  {
    id: 'tina-burner',
    name: 'Tina Burner',
    season: 13,
    finishingPosition: 7,
    ageAtShow: 39,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/tina-burner.webp',
    entranceQuote: 'Didn\'t your parents ever teach you not to play with fire? Now let\'s turn it and burn it bitches!',
    farewellQuote: '',
    snatchGameCharacter: 'Richard Simmons',
    instagramHandle: 'thetinaburner'
  },
  {
    id: 'denali',
    name: 'Denali',
    season: 13,
    finishingPosition: 8,
    ageAtShow: 28,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/denali.webp',
    entranceQuote: 'Lemme break the ice',
    farewellQuote: '',
    snatchGameCharacter: 'Jonathan Van Ness',
    instagramHandle: 'denalifoxx'
  },
  {
    id: 'elliott-with-2-ts',
    name: 'Elliott with 2 Ts',
    season: 13,
    finishingPosition: 9,
    ageAtShow: 26,
    hometown: 'Las Vegas, Nevada',
    hometownCoordinates: cityCoordinates['Las Vegas, Nevada'],
    headshotUrl: '/images/headshots/elliott-with-2-ts.webp',
    entranceQuote: 'I\'m the queen you want to see, **** with Two T\'s. Okay, uh uh uh, okay? Get into it',
    farewellQuote: '',
    snatchGameCharacter: 'Rue McClanahan',
    instagramHandle: 'therealelliottqueen'
  },
  {
    id: 'lala-ri',
    name: 'LaLa Ri',
    season: 13,
    finishingPosition: 10,
    ageAtShow: 30,
    hometown: 'Atlanta, Georgia',
    hometownCoordinates: cityCoordinates['Atlanta, Georgia'],
    headshotUrl: '/images/headshots/lala-ri.webp',
    entranceQuote: 'Oh, what you say, what you say? **** is here to slay',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'misslalari'
  },
  {
    id: 'tamisha-iman',
    name: 'Tamisha Iman',
    season: 13,
    finishingPosition: 11,
    ageAtShow: 49,
    hometown: 'Atlanta, Georgia',
    hometownCoordinates: cityCoordinates['Atlanta, Georgia'],
    headshotUrl: '/images/headshots/tamisha-iman.webp',
    entranceQuote: 'Holla at me, I know you know me, holla at me, I know you know me. **** is here',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'tamisha_iman'
  },
  {
    id: 'joey-jay',
    name: 'Joey Jay',
    season: 13,
    finishingPosition: 12,
    ageAtShow: 30,
    hometown: 'Phoenix, Arizona',
    hometownCoordinates: cityCoordinates['Phoenix, Arizona'],
    headshotUrl: '/images/headshots/joeyjay.webp',
    entranceQuote: 'Filler queen',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'joeyjayisgay'
  },
  {
    id: 'kahmora-hall',
    name: 'Kahmora Hall',
    season: 13,
    finishingPosition: 13,
    ageAtShow: 28,
    hometown: 'Chicago, Illinois',
    hometownCoordinates: cityCoordinates['Chicago, Illinois'],
    headshotUrl: '/images/headshots/kahmora-hall.webp',
    entranceQuote: 'The Mackie doll is finally out of her box',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'kahmorahall'
  },

  // Season 14
  {
    id: 'willow-pill',
    name: 'Willow Pill',
    season: 14,
    finishingPosition: 1,
    ageAtShow: 26,
    hometown: 'Denver, Colorado',
    hometownCoordinates: cityCoordinates['Denver, Colorado'],
    headshotUrl: '/images/headshots/willow-pill.webp',
    entranceQuote: 'Where am I?',
    farewellQuote: '',
    snatchGameCharacter: 'Drew Barrymore',
    instagramHandle: 'willowpill'
  },
  {
    id: 'lady-camden',
    name: 'Lady Camden',
    season: 14,
    finishingPosition: 2,
    ageAtShow: 31,
    hometown: 'Sacramento, California',
    hometownCoordinates: cityCoordinates['Sacramento, California'],
    headshotUrl: '/images/headshots/lady-camden.webp',
    entranceQuote: 'Hello, you sexy bitches!',
    farewellQuote: '',
    snatchGameCharacter: 'William Shakespeare',
    instagramHandle: 'ladycamden'
  },
  {
    id: 'angeria-paris-vanmicheals',
    name: 'Angeria Paris VanMicheals',
    season: 14,
    finishingPosition: 3,
    ageAtShow: 27,
    hometown: 'Atlanta, Georgia',
    hometownCoordinates: cityCoordinates['Atlanta, Georgia'],
    headshotUrl: '/images/headshots/angeria-paris-van-michaels.webp',
    entranceQuote: 'The name\'s ****, but you can call me ****. Now, let\'s make it shake, honey!',
    farewellQuote: '',
    snatchGameCharacter: 'Tammie Brown',
    instagramHandle: 'angeriavm'
  },
  {
    id: 'bosco',
    name: 'Bosco',
    season: 14,
    finishingPosition: 3,
    ageAtShow: 28,
    hometown: 'Seattle, Washington',
    hometownCoordinates: cityCoordinates['Seattle, Washington'],
    headshotUrl: '/images/headshots/bosco.webp',
    entranceQuote: 'Alright, let\'s get out there today and make a difference.',
    farewellQuote: '',
    snatchGameCharacter: 'Gwyneth Paltrow',
    instagramHandle: 'bosco_drag'
  },
  {
    id: 'daya-betty',
    name: 'Daya Betty',
    season: 14,
    finishingPosition: 3,
    ageAtShow: 25,
    hometown: 'Springfield, Missouri',
    hometownCoordinates: cityCoordinates['Springfield, Missouri'],
    headshotUrl: '/images/headshots/daya-betty.webp',
    entranceQuote: 'You **** be ready!',
    farewellQuote: '',
    snatchGameCharacter: 'Ozzy Osbourne',
    instagramHandle: 'dayabetty'
  },
  {
    id: 'deja-skye',
    name: 'DeJa Skye',
    season: 14,
    finishingPosition: 6,
    ageAtShow: 31,
    hometown: 'Fresno, California',
    hometownCoordinates: cityCoordinates['Fresno, California'],
    headshotUrl: '/images/headshots/deja-sky.webp',
    entranceQuote: 'Alright, season 14. Let\'s get thickening!',
    farewellQuote: '',
    snatchGameCharacter: 'Lil Jon',
    instagramHandle: 'dejaskye'
  },
  {
    id: 'jorgeous',
    name: 'Jorgeous',
    season: 14,
    finishingPosition: 7,
    ageAtShow: 21,
    hometown: 'Nashville, Tennessee',
    hometownCoordinates: cityCoordinates['Nashville, Tennessee'],
    headshotUrl: '/images/headshots/jorgeous.webp',
    entranceQuote: 'Hello-tis! It is gorgeous like ****. Ow!',
    farewellQuote: '',
    snatchGameCharacter: 'Ilana Glazer',
    instagramHandle: 'jorgeous_1'
  },
  {
    id: 'jasmine-kennedie',
    name: 'Jasmine Kennedie',
    season: 14,
    finishingPosition: 8,
    ageAtShow: 22,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/jasmine-kennedie.webp',
    entranceQuote: 'Oh this, y\'all? Is just the entry look.',
    farewellQuote: '',
    snatchGameCharacter: 'Betsy DeVos',
    instagramHandle: 'jasminekennedie'
  },
  {
    id: 'kerri-colby',
    name: 'Kerri Colby',
    season: 14,
    finishingPosition: 9,
    ageAtShow: 24,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/kerri-colby.webp',
    entranceQuote: 'I have one thing to say, baby, you already know every kiss, begins with a ****',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'kerricolby'
  },
  {
    id: 'maddy-morphosis',
    name: 'Maddy Morphosis',
    season: 14,
    finishingPosition: 10,
    ageAtShow: 26,
    hometown: 'Fayetteville, Arkansas',
    hometownCoordinates: cityCoordinates['Fayetteville, Arkansas'],
    headshotUrl: '/images/headshots/maddy-morphosis.webp',
    entranceQuote: 'You ready to pitch a tent, America? The camp queen is here!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'maddymorphosis'
  },
  {
    id: 'orion-story',
    name: 'Orion Story',
    season: 14,
    finishingPosition: 11,
    ageAtShow: 25,
    hometown: 'Grand Rapids, Michigan',
    hometownCoordinates: cityCoordinates['Grand Rapids, Michigan'],
    headshotUrl: '/images/headshots/orion-story.webp',
    entranceQuote: 'Hello, RuPaul? Yes, we\'ve been trying to reach you regarding your car\'s extended warranty? Oh, perfect, well then I just have one more question for you. Are you ready boots?',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'theorionstory'
  },
  {
    id: 'kornbread-jete',
    name: 'Kornbread "The Snack" Jeté',
    season: 14,
    finishingPosition: 12,
    ageAtShow: 29,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/kornbread-jete.webp',
    entranceQuote: 'Is you hungry? \'Cause bitch, I\'m baked!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a'
  },
  {
    id: 'alyssa-hunter',
    name: 'Alyssa Hunter',
    season: 14,
    finishingPosition: 13,
    ageAtShow: 26,
    hometown: 'Cataño, Puerto Rico',
    hometownCoordinates: cityCoordinates['Cataño, Puerto Rico'],
    headshotUrl: '/images/headshots/alyssa-hunter.webp',
    entranceQuote: 'Hola! I hope you guys are ready to be slayed, \'cause it\'s **** season, bitches!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'alyssahunter__'
  },
  {
    id: 'june-jambalaya',
    name: 'June Jambalaya',
    season: 14,
    finishingPosition: 14,
    ageAtShow: 29,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/june-jambalaya.webp',
    entranceQuote: 'Grab a fork ladies, **** is served.',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'junejambalaya'
  },

  // Season 15
  {
    id: 'sasha-colby',
    name: 'Sasha Colby',
    season: 15,
    finishingPosition: 1,
    ageAtShow: 37,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/sasha-colby.webp',
    entranceQuote: 'Period.',
    farewellQuote: '',
    snatchGameCharacter: 'Jan Crouch',
    instagramHandle: 'sashacolby'
  },
  {
    id: 'anetra',
    name: 'Anetra',
    season: 15,
    finishingPosition: 2,
    ageAtShow: 25,
    hometown: 'Las Vegas, Nevada',
    hometownCoordinates: cityCoordinates['Las Vegas, Nevada'],
    headshotUrl: '/images/headshots/anetra.webp',
    entranceQuote: 'What?',
    farewellQuote: '',
    snatchGameCharacter: 'Gorgena Ramsey',
    instagramHandle: 'anetra'
  },
  {
    id: 'luxx-noir-london',
    name: 'Luxx Noir London',
    season: 15,
    finishingPosition: 3,
    ageAtShow: 22,
    hometown: 'East Orange, New Jersey',
    hometownCoordinates: cityCoordinates['East Orange, New Jersey'],
    headshotUrl: '/images/headshots/luxx-noir-london.webp',
    entranceQuote: '"Gagged them a bit. For sure.',
    farewellQuote: '',
    snatchGameCharacter: 'Amanda Lepore',
    instagramHandle: 'luxxnoirlondon'
  },
  {
    id: 'mistress-isabelle-brooks',
    name: 'Mistress Isabelle Brooks',
    season: 15,
    finishingPosition: 3,
    ageAtShow: 24,
    hometown: 'Houston, Texas',
    hometownCoordinates: cityCoordinates['Houston, Texas'],
    headshotUrl: '/images/headshots/mistress-isabelle-brooks.webp',
    entranceQuote: 'Don\'t be fooled, the camera adds 10 pounds!',
    farewellQuote: '',
    snatchGameCharacter: 'Rosie O\'Donnell',
    instagramHandle: 'mistressisabellebrooks'
  },
  {
    id: 'loosey-laduca',
    name: 'Loosey LaDuca',
    season: 15,
    finishingPosition: 5,
    ageAtShow: 32,
    hometown: 'Ansonia, Connecticut',
    hometownCoordinates: cityCoordinates['Ansonia, Connecticut'],
    headshotUrl: '/images/headshots/loosey-laduca.webp',
    entranceQuote: '"Oh ****, you\'ve got some slaying to do! Oh!',
    farewellQuote: '',
    snatchGameCharacter: 'Joan Rivers',
    instagramHandle: 'looseyladuca'
  },
  {
    id: 'salina-estitties',
    name: 'Salina EsTitties',
    season: 15,
    finishingPosition: 6,
    ageAtShow: 31,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/salina-estitties.webp',
    entranceQuote: 'Is this the meeting for the itty bitty **** committee? \'Cause they\'re here!',
    farewellQuote: '',
    snatchGameCharacter: 'The Virgin Mary',
    instagramHandle: 'estitties'
  },
  {
    id: 'marcia-marcia-marcia',
    name: 'Marcia Marcia Marcia',
    season: 15,
    finishingPosition: 7,
    ageAtShow: 25,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/marcia-marcia-marcia.webp',
    entranceQuote: 'Ow! My nose!',
    farewellQuote: '',
    snatchGameCharacter: 'Tim Gunn',
    instagramHandle: 'marciax3nyc'
  },
  {
    id: 'malaysia-babydoll-foxx',
    name: 'Malaysia Babydoll Foxx',
    season: 15,
    finishingPosition: 8,
    ageAtShow: 32,
    hometown: 'Miami, Florida',
    hometownCoordinates: cityCoordinates['Miami, Florida'],
    headshotUrl: '/images/headshots/malaysia-babydoll-foxx.webp',
    entranceQuote: 'I\'m just here to **** shit up!',
    farewellQuote: '',
    snatchGameCharacter: 'Saucy Santana',
    instagramHandle: 'foxxy_doll'
  },
  {
    id: 'spice',
    name: 'Spice',
    season: 15,
    finishingPosition: 9,
    ageAtShow: 23,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/spice.webp',
    entranceQuote: 'Sweetie, that was my line!',
    farewellQuote: '',
    snatchGameCharacter: 'Miley Cyrus',
    instagramHandle: 'callmespice'
  },
  {
    id: 'jax',
    name: 'Jax',
    season: 15,
    finishingPosition: 10,
    ageAtShow: 25,
    hometown: 'Darien, Connecticut',
    hometownCoordinates: cityCoordinates['Darien, Connecticut'],
    headshotUrl: '/images/headshots/jax.webp',
    entranceQuote: 'Make room for your MVP, spelled ****',
    farewellQuote: '',
    snatchGameCharacter: 'Mona Lisa',
    instagramHandle: 'getjaxed'
  },
  {
    id: 'aura-mayari',
    name: 'Aura Mayari',
    season: 15,
    finishingPosition: 11,
    ageAtShow: 30,
    hometown: 'Nashville, Tennessee',
    hometownCoordinates: cityCoordinates['Nashville, Tennessee'],
    headshotUrl: '/images/headshots/aura-mayari.webp',
    entranceQuote: 'Do you feel that aura? I bet you do.',
    farewellQuote: '',
    snatchGameCharacter: 'Bretman Rock',
    instagramHandle: 'auramayari'
  },
  {
    id: 'robin-fierce',
    name: 'Robin Fierce',
    season: 15,
    finishingPosition: 12,
    ageAtShow: 26,
    hometown: 'Hartford, Connecticut',
    hometownCoordinates: cityCoordinates['Hartford, Connecticut'],
    headshotUrl: '/images/headshots/robin-fierce.webp',
    entranceQuote: 'Mirror mirror on the wall, who\'s the fiercest queen of them all? It\'s me.',
    farewellQuote: '',
    snatchGameCharacter: 'Karen Huger',
    instagramHandle: 'therobinfierce'
  },
  {
    id: 'amethyst',
    name: 'Amethyst',
    season: 15,
    finishingPosition: 13,
    ageAtShow: 27,
    hometown: 'West Hartford, Connecticut',
    hometownCoordinates: cityCoordinates['West Hartford, Connecticut'],
    headshotUrl: '/images/headshots/amethyst.webp',
    entranceQuote: 'Is this thing on?',
    farewellQuote: '',
    snatchGameCharacter: 'Tan Mom',
    instagramHandle: 'thatssoamethyst'
  },
  {
    id: 'sugar',
    name: 'Sugar',
    season: 15,
    finishingPosition: 14,
    ageAtShow: 23,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/sugar.webp',
    entranceQuote: 'Ugh, whatever!',
    farewellQuote: '',
    snatchGameCharacter: 'Trisha Paytas',
    instagramHandle: 'sugarsworld'
  },
  {
    id: 'princess-poppy',
    name: 'Princess Poppy',
    season: 15,
    finishingPosition: 15,
    ageAtShow: 26,
    hometown: 'San Francisco, California',
    hometownCoordinates: cityCoordinates['San Francisco, California'],
    headshotUrl: '/images/headshots/princess-poppy.webp',
    entranceQuote: 'I\'m homo... phobic.',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'poppyprincesspoppy'
  },
  {
    id: 'irene-dubois',
    name: 'Irene Dubois',
    season: 15,
    finishingPosition: 16,
    ageAtShow: 29,
    hometown: 'Seattle, Washington',
    hometownCoordinates: cityCoordinates['Seattle, Washington'],
    headshotUrl: '/images/headshots/irene-dubois.webp',
    entranceQuote: '(sneezes) "Okay, someone\'s wearing cheap perfume. Oh wait, it\'s me!"',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'irenethealien'
  },

  // Season 16
  {
    id: 'nymphia-wind',
    name: 'Nymphia Wind',
    season: 16,
    finishingPosition: 1,
    ageAtShow: 27,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/nymphia-wind.webp',
    entranceQuote: 'Bananas.',
    farewellQuote: '',
    snatchGameCharacter: 'Jane Goodall',
    instagramHandle: 'nymphia'
  },
  {
    id: 'sapphira-cristal',
    name: 'Sapphira Cristál',
    season: 16,
    finishingPosition: 2,
    ageAtShow: 34,
    hometown: 'Philadelphia, Pennsylvania',
    hometownCoordinates: cityCoordinates['Philadelphia, Pennsylvania'],
    headshotUrl: '/images/headshots/sapphira-cristal.webp',
    entranceQuote: 'Ooooh, Ooooooh! I think this place is haunted.',
    farewellQuote: '',
    snatchGameCharacter: 'James Brown',
    instagramHandle: 'sapphiracristal'
  },
  {
    id: 'plane-jane',
    name: 'Plane Jane',
    season: 16,
    finishingPosition: 3,
    ageAtShow: 24,
    hometown: 'Boston, Massachusetts',
    hometownCoordinates: cityCoordinates['Boston, Massachusetts'],
    headshotUrl: '/images/headshots/plane-jane.webp',
    entranceQuote: 'Fasten your seatbelts, \'cause this **** always goes down.',
    farewellQuote: '',
    snatchGameCharacter: 'Jelena Karleuša',
    instagramHandle: 'the_planejane'
  },
  {
    id: 'q',
    name: 'Q',
    season: 16,
    finishingPosition: 4,
    ageAtShow: 29,
    hometown: 'Kansas City, Missouri',
    hometownCoordinates: cityCoordinates['Kansas City, MO'],
    headshotUrl: '/images/headshots/q.webp',
    entranceQuote: 'Cue the music, because the show is about to start!',
    farewellQuote: '',
    snatchGameCharacter: 'Amelia Earhart',
    instagramHandle: 'living4q'
  },
  {
    id: 'morphine-love-dion',
    name: 'Morphine Love Dion',
    season: 16,
    finishingPosition: 5,
    ageAtShow: 25,
    hometown: 'Miami, Florida',
    hometownCoordinates: cityCoordinates['Miami, Florida'],
    headshotUrl: '/images/headshots/morphine-love-dion.webp',
    entranceQuote: 'The beauty and the booty is here, a darlo todo!',
    farewellQuote: '',
    snatchGameCharacter: 'Anna Sorokin',
    instagramHandle: 'morphinelovemua'
  },
  {
    id: 'dawn',
    name: 'Dawn',
    season: 16,
    finishingPosition: 6,
    ageAtShow: 24,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/dawn.webp',
    entranceQuote: 'Rise and shine, motherfuckers; it\'s ****.',
    farewellQuote: '',
    snatchGameCharacter: 'Meghan McCain',
    instagramHandle: 'upuntil.dawn'
  },
  {
    id: 'mhiya-iman-lepaige',
    name: 'Mhi\'ya Iman Le\'Paige',
    season: 16,
    finishingPosition: 7,
    ageAtShow: 34,
    hometown: 'Miami, Florida',
    hometownCoordinates: cityCoordinates['Miami, Florida'],
    headshotUrl: '/images/headshots/mhiya-iman-lepaige.webp',
    entranceQuote: 'The \'Queen of Flips.\' I don\'t set the bar, I flips it.',
    farewellQuote: '',
    snatchGameCharacter: 'Trina\'s Cousin Shaquita'
  },
  {
    id: 'plasma',
    name: 'Plasma',
    season: 16,
    finishingPosition: 8,
    ageAtShow: 24,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/plasma.webp',
    entranceQuote: 'Darling, why give blood when you can sell... ****?',
    farewellQuote: '',
    snatchGameCharacter: 'Patti LuPone',
    instagramHandle: 'plasmanyc'
  },
  {
    id: 'xunami-muse',
    name: 'Xunami Muse',
    season: 16,
    finishingPosition: 9,
    ageAtShow: 33,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/xunami-muse.webp',
    entranceQuote: 'Yer! The natural disaster has arrived.',
    farewellQuote: '',
    snatchGameCharacter: 'The Gold Tooth Fairy',
    instagramHandle: 'xunamimuse'
  },
  {
    id: 'megami',
    name: 'Megami',
    season: 16,
    finishingPosition: 10,
    ageAtShow: 33,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/megami.webp',
    entranceQuote: 'A goddess amongst men.',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'megaminyc'
  },
  {
    id: 'geneva-karr',
    name: 'Geneva Karr',
    season: 16,
    finishingPosition: 11,
    ageAtShow: 30,
    hometown: 'Brownsville, Texas',
    hometownCoordinates: cityCoordinates['Brownsville, Texas'],
    headshotUrl: '/images/headshots/geneva-karr.webp',
    entranceQuote: 'Viva Mexico, \'Karr-brones\'!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'geneva_karr'
  },
  {
    id: 'amanda-tori-meating',
    name: 'Amanda Tori Meating',
    season: 16,
    finishingPosition: 12,
    ageAtShow: 26,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/amanda-tori-meating.webp',
    entranceQuote: 'Wait a second, this place doesn\'t have a bidet!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'amandatorimeating'
  },
  {
    id: 'mirage',
    name: 'Mirage',
    season: 16,
    finishingPosition: 13,
    ageAtShow: 29,
    hometown: 'Las Vegas, Nevada',
    hometownCoordinates: cityCoordinates['Las Vegas, Nevada'],
    headshotUrl: '/images/headshots/mirage.webp',
    entranceQuote: 'I hope you trash bags are ready to lose!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'mirage_amuro'
  },
  {
    id: 'hershii-liqcour-jete',
    name: 'Hershii LiqCour-Jeté',
    season: 16,
    finishingPosition: 14,
    ageAtShow: 31,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/hershii-liqcour-jete.webp',
    entranceQuote: 'I... did not prepare for this.',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'hershiiliqcour'
  },

  // Season 17
  {
    id: 'onya-nurve',
    name: 'Onya Nurve',
    season: 17,
    finishingPosition: 1,
    ageAtShow: 31,
    hometown: 'Cleveland, Ohio',
    hometownCoordinates: cityCoordinates['Cleveland, Ohio'],
    headshotUrl: '/images/headshots/onya-nurve.webp',
    entranceQuote: 'Well, it do take ****.',
    farewellQuote: '',
    snatchGameCharacter: 'Eddie Murphy',
    instagramHandle: 'onyanurve'
  },
  {
    id: 'jewels-sparkles',
    name: 'Jewels Sparkles',
    season: 17,
    finishingPosition: 2,
    ageAtShow: 23,
    hometown: 'Tampa, Florida',
    hometownCoordinates: cityCoordinates['Tampa, Florida'],
    headshotUrl: '/images/headshots/jewels-sparkles.webp',
    entranceQuote: 'Don\'t worry, I\'m not just a bitch; I\'m that bitch.',
    farewellQuote: '',
    snatchGameCharacter: 'Bigfoot',
    instagramHandle: 'thejewelssparkles'
  },
  {
    id: 'lexi-love',
    name: 'Lexi Love',
    season: 17,
    finishingPosition: 3,
    ageAtShow: 34,
    hometown: 'Louisville, Kentucky',
    hometownCoordinates: cityCoordinates['Louisville, Kentucky'],
    headshotUrl: '/images/headshots/lexi.webp',
    entranceQuote: 'Why y\'all gagging? I haven\'t even stepped on any necks yet.',
    farewellQuote: '',
    snatchGameCharacter: 'Gilbert Gottfried',
    instagramHandle: 'lexilovets'
  },
  {
    id: 'sam-star',
    name: 'Sam Star',
    season: 17,
    finishingPosition: 3,
    ageAtShow: 24,
    hometown: 'Leeds, Alabama',
    hometownCoordinates: cityCoordinates['Leeds, Alabama'],
    headshotUrl: '/images/headshots/sam-star.webp',
    entranceQuote: 'Well, I heard y\'all were looking for America\'s Next Drag Superstar!',
    farewellQuote: '',
    snatchGameCharacter: 'Kim Gravel',
    instagramHandle: 'samstarqueen'
  },
  {
    id: 'suzie-toot',
    name: 'Suzie Toot',
    season: 17,
    finishingPosition: 5,
    ageAtShow: 24,
    hometown: 'Fort Lauderdale, Florida',
    hometownCoordinates: cityCoordinates['Fort Lauderdale, Florida'],
    headshotUrl: '/images/headshots/suzie-toot.webp',
    entranceQuote: 'I\'ve always wanted my name in the papers.',
    farewellQuote: '',
    snatchGameCharacter: 'Ellen Greene',
    instagramHandle: 'susie.toot'
  },
  {
    id: 'lana-jarae',
    name: 'Lana Ja\'Rae',
    season: 17,
    finishingPosition: 6,
    ageAtShow: 22,
    hometown: 'New York, New York',
    hometownCoordinates: cityCoordinates['New York, New York'],
    headshotUrl: '/images/headshots/lana-jarae.webp',
    entranceQuote: 'Gouda morning, Ja\'Reamers.',
    farewellQuote: '',
    snatchGameCharacter: 'Rosa Parks'
  },
  {
    id: 'lydia-b-kollins',
    name: 'Lydia B Kollins',
    season: 17,
    finishingPosition: 7,
    ageAtShow: 23,
    hometown: 'Pittsburgh, Pennsylvania',
    hometownCoordinates: cityCoordinates['Pittsburgh, Pennsylvania'],
    headshotUrl: '/images/headshots/lydia-b-kollins.webp',
    entranceQuote: 'Did someone say my name three times? (moans)',
    farewellQuote: '',
    snatchGameCharacter: 'David Lynch',
    instagramHandle: 'foreheadbrows'
  },
  {
    id: 'arrietty',
    name: 'Arrietty',
    season: 17,
    finishingPosition: 8,
    ageAtShow: 28,
    hometown: 'Seattle, Washington',
    hometownCoordinates: cityCoordinates['Seattle, Washington'],
    headshotUrl: '/images/headshots/arrietty.webp',
    entranceQuote: 'Hi!',
    farewellQuote: '',
    snatchGameCharacter: 'Baby Cupid',
    instagramHandle: 'arrietty_theelf'
  },
  {
    id: 'kori-king',
    name: 'Kori King',
    season: 17,
    finishingPosition: 9,
    ageAtShow: 24,
    hometown: 'Boston, Massachusetts',
    hometownCoordinates: cityCoordinates['Boston, Massachusetts'],
    headshotUrl: '/images/headshots/kori-king.webp',
    entranceQuote: '*sip* Ahhh. Good morning, kingdom!',
    farewellQuote: '',
    snatchGameCharacter: 'Big Ang',
    instagramHandle: 'koriking'
  },
  {
    id: 'acacia-forgot',
    name: 'Acacia Forgot',
    season: 17,
    finishingPosition: 10,
    ageAtShow: 28,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/acacia-forgot.webp',
    entranceQuote: 'Totally tubular.',
    farewellQuote: '',
    snatchGameCharacter: 'Trisha Paytas',
    instagramHandle: 'acaciaforgot'
  },
  {
    id: 'crystal-envy',
    name: 'Crystal Envy',
    season: 17,
    finishingPosition: 11,
    ageAtShow: 27,
    hometown: 'Asbury Park, New Jersey',
    hometownCoordinates: cityCoordinates['Asbury Park, New Jersey'],
    headshotUrl: '/images/headshots/crystal-envy.webp',
    entranceQuote: 'Yeah, I\'d **** me too.',
    farewellQuote: '',
    snatchGameCharacter: 'Nichole Richie',
    instagramHandle: 'thecrystalenvy'
  },
  {
    id: 'hormona-lisa',
    name: 'Hormona Lisa',
    season: 17,
    finishingPosition: 12,
    ageAtShow: 30,
    hometown: 'Chattanooga, Tennessee',
    hometownCoordinates: cityCoordinates['Chattanooga, Tennessee'],
    headshotUrl: '/images/headshots/hormona-lisa.webp',
    entranceQuote: 'Hello, loyal subjects. It is I, ****, at your service. *laugh* Wow, that was annoying.',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'hormona_lisa'
  },
  {
    id: 'joella',
    name: 'Joella',
    season: 17,
    finishingPosition: 13,
    ageAtShow: 25,
    hometown: 'Los Angeles, California',
    hometownCoordinates: cityCoordinates['Los Angeles, California'],
    headshotUrl: '/images/headshots/joella.webp',
    entranceQuote: '大家好, 大家好, welcome to the **** Dynasty, bitch!',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'thejoelladynasty'
  },
  {
    id: 'lucky-starzzz',
    name: 'Lucky Starzzz',
    season: 17,
    finishingPosition: 14,
    ageAtShow: 26,
    hometown: 'Miami, Florida',
    hometownCoordinates: cityCoordinates['Miami, Florida'],
    headshotUrl: '/images/headshots/lucky-starzzz.webp',
    entranceQuote: 'Oh, daddy, I think I stained the sheets.',
    farewellQuote: '',
    snatchGameCharacter: 'n/a',
    instagramHandle: 'theluckystarzzz'
  }
];

// Utility functions for contestant database
export const getContestantById = (id: string): Contestant | undefined => {
  return contestants.find(contestant => contestant.id === id);
};

export const getContestantsByName = (name: string): Contestant[] => {
  const searchTerm = name.toLowerCase();
  return contestants.filter(contestant => 
    contestant.name.toLowerCase().includes(searchTerm)
  );
};

export const getContestantsBySeason = (season: number): Contestant[] => {
  return contestants.filter(contestant => contestant.season === season);
};

export const getAllContestantNames = (): string[] => {
  return contestants.map(contestant => contestant.name);
};

export const getRandomContestant = (): Contestant => {
  const randomIndex = Math.floor(Math.random() * contestants.length);
  return contestants[randomIndex];
};

/**
 * Filter contestants by game mode settings
 * @param firstTenSeasons - If true, only include seasons 1-10
 * @param topSevenOnly - If true, only include contestants who placed in top 7
 */
export const getContestantsByMode = (
  firstTenSeasons: boolean,
  topSevenOnly: boolean
): Contestant[] => {
  return contestants.filter(contestant => {
    if (firstTenSeasons && contestant.season > 10) {
      return false;
    }
    if (topSevenOnly && contestant.finishingPosition > 7) {
      return false;
    }
    return true;
  });
};

/**
 * Get contestants by name filtered by game mode
 */
export const getContestantsByNameAndMode = (
  name: string,
  firstTenSeasons: boolean,
  topSevenOnly: boolean
): Contestant[] => {
  const searchTerm = name.toLowerCase();
  return getContestantsByMode(firstTenSeasons, topSevenOnly).filter(contestant =>
    contestant.name.toLowerCase().includes(searchTerm)
  );
};

// Validation function to ensure database integrity
export const validateContestantDatabase = (): {
  isValid: boolean;
  errors: string[];
} => {
  const errors: string[] = [];
  const seenIds = new Set<string>();

  for (const contestant of contestants) {
    // Check for duplicate IDs
    if (seenIds.has(contestant.id)) {
      errors.push(`Duplicate contestant ID: ${contestant.id}`);
    }
    seenIds.add(contestant.id);

    // Check required fields
    if (!contestant.name) errors.push(`Missing name for ID: ${contestant.id}`);
    if (!contestant.hometown) errors.push(`Missing hometown for ID: ${contestant.id}`);
    if (!contestant.hometownCoordinates) {
      errors.push(`Missing hometown coordinates for ID: ${contestant.id}`);
    } else {
      if (typeof contestant.hometownCoordinates.latitude !== 'number') {
        errors.push(`Invalid latitude for ID: ${contestant.id}`);
      }
      if (typeof contestant.hometownCoordinates.longitude !== 'number') {
        errors.push(`Invalid longitude for ID: ${contestant.id}`);
      }
    }
    if (contestant.season < 1 || contestant.season > 17) {
      errors.push(`Invalid season for ID: ${contestant.id}`);
    }
    if (contestant.finishingPosition < 1) {
      errors.push(`Invalid finishing position for ID: ${contestant.id}`);
    }
    if (contestant.ageAtShow < 18 || contestant.ageAtShow > 60) {
      errors.push(`Suspicious age for ID: ${contestant.id}`);
    }
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};
